<template>
  <div>
    <!-- mobile -->
    <b-collapse id="modal-menu" v-model="alternativeAccordions['main-modal-menu']">
      <div class="card">
        <div class="card-header">
          <div class="flex-grow-1"></div>
          <div>
            <b-button v-b-toggle.modal-menu variant="light">
              <span class="material-icons-outlined">clear</span>
            </b-button>
          </div>
        </div>
        <div class="card-body">
          <div class="scroller">
            <div class="items">
              <template v-for="(menu, index) in items">
                <template v-if="
                  (menu.permissions === 'whitelabel' &&
                    $store.state.admin.whitelabel.account_id ===
                    $store.state.account.id) ||
                  (menu.scope === 'whatsapp/jv' &&
                    (whitelabelId === null || $live.isMeta)) ||
                  (menu.scope === 'whatsapp' &&
                    (whitelabelId === null || available.whatsapp)) ||
                  ((menu.scope === 'live' || menu.scope === 'flow') &&
                    $live.acceptConnect()) ||
                  (menu.permissions !== 'yupchat' &&
                    menu.permissions !== 'whitelabel' &&
                    menu.scope !== 'whatsapp/jv' &&
                    menu.scope !== 'whatsapp' &&
                    menu.scope !== 'live' &&
                    menu.scope !== 'flow')
                ">
                  <!-- div :key="index">
                    <b-button>
                      <i v-html="menu.embed" v-if="menu.embed"></i>
                      <i :class="`icon-font ${menu.icon}`" v-else-if="menu.icon"></i>
                    </b-button>
                  </div -->

                  <div :key="index" v-if="menu.subItems">
                    <b-button class="menu btn-light" :class="{ active: activeMainMenu(currentRoute, menu) }"
                      variant="light" v-b-toggle="`modal-menu-accordion-${index}`">
                      <i v-html="menu.embed" v-if="menu.embed"></i>
                      <i :class="`icon-font ${menu.icon}`" v-else-if="menu.icon"></i>
                      <i class="icon-font ${menu.icon}`" v-else-if="menu.icon"></i>
                      <i class="show-sub">
                        <span class="material-icons-outlined">navigate_next</span>
                      </i>
                      <div class="sub-title">{{ menu.title }}</div>
                      <!-- omni notification -->
                      <!-- template v-if="menu.scope === 'live' && account.is_agent">
                        <audio
                          controls
                          class="sr-only"
                          ref="soundNotification"
                          id="soundNotification"
                          :muted="$live.volume <= 0">
                          <source
                            src="/sounds/notification.ogg"
                            type="audio/ogg; codecs=vorbis"
                          />
                          <source src="/sounds/notification.mp3" type="audio/mpeg" />
                        </audio>
                        <div
                          :class="{
                            'omni-pushs': true,
                            'omni-notifications': $live.hasNotifications,
                            'bg-success': $live.status === 'AVAILABLE',
                            'bg-warning': $live.status === 'UNAVAILABLE',
                            'bg-info': $live.status === 'BREAK',
                            'bg-danger': $live.status === 'OFFLINE',
                          }"
                          v-if="account.is_agent"></div>
                      </template -->
                    </b-button>
                    <b-collapse class="modal-submenu" role="tabpanel" accordion="modal-menu-accordion"
                      :id="`modal-menu-accordion-${index}`" v-model="alternativeAccordions[index]">
                      <div class="card">
                        <div class="card-header align-items-center">
                          <div>
                            <b-button variant="light" v-b-toggle="`modal-menu-accordion-${index}`">
                              <span class="material-icons-outlined">chevron_left</span>
                            </b-button>
                          </div>
                          <div class="flex-grow-1">{{ menu.title }}</div>
                        </div>
                        <div class="card-body">
                          <div class="scroller">
                            <div class="items">
                              <template v-for="(subMenu, jindex) in menu.subItems">
                                <template v-if="
                                  subMenu.permissions === 'yupchat'
                                    ? whitelabelId === null
                                    : true
                                ">
                                  <div :key="jindex">
                                    <router-link @click.native="closeModalMenus()" :to="subMenu.link"
                                      class="menu btn btn-light" :class="{
                                        active: subMenu.link === currentRoute,
                                      }" v-if="subMenu.link">
                                      <i :class="`icon-font ${subMenu.icon}`" v-if="subMenu.icon"></i>
                                      <i class="svg" v-else-if="subMenu.embed" v-html="subMenu.embed"></i>
                                      <span class="sr-only">{{
                                        subMenu.title
                                      }}</span>
                                      <div class="sub-title">
                                        {{ subMenu.title }}
                                      </div>
                                    </router-link>
                                    <button @click="closeModalMenus()" class="menu btn btn-light" v-else>
                                      <i :class="`icon-font ${subMenu.icon}`" v-if="subMenu.icon"></i>
                                      <i class="svg" v-else-if="subMenu.embed" v-html="subMenu.embed"></i>
                                      <span class="sr-only">{{
                                        subMenu.title
                                      }}</span>
                                    </button>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                  <div :key="index" v-else>
                    <router-link @click.native="closeModalMenus()" :to="menu.link" class="menu btn btn-light"
                      :class="{ active: menu.link === currentRoute }" v-if="menu.link">
                      <i :class="`icon-font ${menu.icon}`" v-if="menu.icon"></i>
                      <i class="svg" v-else-if="menu.embed" v-html="menu.embed"></i>
                      <span class="sr-only">{{ menu.title }}</span>
                      <div class="sub-title">{{ menu.title }}</div>
                    </router-link>
                    <button @click="closeModalMenus()" class="menu btn btn-light" v-else>
                      <i :class="`icon-font ${menu.icon}`" v-if="menu.icon"></i>
                      <i class="svg" v-else-if="menu.embed" v-html="menu.embed"></i>
                      <span class="sr-only">{{ menu.title }}</span>
                      <div class="sub-title">{{ menu.title }}</div>
                    </button>
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </b-collapse>

    <!-- Desktop -->
    <div id="sidebar">
      <scrollbar role="tablist" class="accordion" :class="{ hasAccordion }" ref="sidebarScroll">
        <template v-for="(menu, index) in items">
          <template v-if="
            (menu.permissions === 'whitelabel' &&
              $store.state.admin.whitelabel.account_id ===
              $store.state.account.id) ||
            (menu.scope === 'whatsapp/jv' &&
              (whitelabelId === null || $live.isMeta)) ||
            (menu.scope === 'whatsapp' &&
              (whitelabelId === null || available.whatsapp)) ||
            ((menu.scope === 'live' || menu.scope === 'flow' || menu.scope === 'pipelines') &&
              $live.acceptConnect()) ||
            (menu.permissions !== 'yupchat' &&
              menu.permissions !== 'whitelabel' &&
              menu.scope !== 'whatsapp/jv' &&
              menu.scope !== 'whatsapp' &&
              menu.scope !== 'live' &&
              menu.scope !== 'flow' &&
              menu.scope !== 'pipelines')
          ">
            <!-- v-if="isVisible(menu.permissions)" -->
            <div :key="index" v-if="menu.subItems">
              <b-button class="menu" :class="{ active: activeMainMenu(currentRoute, menu) }" variant="light"
                v-b-toggle="`sidebar-accordion-${index}`" v-b-tooltip.hover.right="{ customClass: 'primary-tooltip' }"
                :title="menu.title">
                <i v-html="menu.embed" v-if="menu.embed"></i>
                <i :class="`icon-font ${menu.icon}`" v-else-if="menu.icon"></i>
                <span class="sr-only">{{ menu.title }}</span>
                <!-- omni notification -->
                <template v-if="menu.scope === 'live' && account.is_agent">
                  <audio controls class="sr-only" ref="soundNotification" id="soundNotification" :muted="false">
                    <source src="../../assets/sounds/yupchat-notification.ogg" type="audio/ogg; codecs=vorbis" />
                    <source src="../../assets/sounds/yupchat-notification.mp3" type="audio/mpeg" />
                  </audio>
                  <div :class="{
                    'omni-pushs': true,
                    'omni-notifications': $live.hasNotifications,
                    'bg-success': $live.status === 'AVAILABLE',
                    'bg-warning': $live.status === 'UNAVAILABLE',
                    'bg-info': $live.status === 'BREAK',
                    'bg-danger': $live.status === 'OFFLINE',
                  }" v-if="account.is_agent"></div>
                </template>
              </b-button>
              <b-collapse role="tabpanel" accordion="sidebar-accordion" :id="`sidebar-accordion-${index}`"
                v-model="accordions[index]">
                <template v-for="(subMenu, jindex) in menu.subItems">
                  <template v-if="
                    subMenu.permissions === 'yupchat'
                      ? whitelabelId === null
                      : true
                  ">
                    <router-link :key="jindex" :to="subMenu.link" class="menu btn"
                      :class="{ active: subMenu.link === currentRoute }" v-b-tooltip.hover.right="{
                        customClass: 'primary-tooltip',
                      }" :title="subMenu.title" v-if="subMenu.link">
                      <i :class="`icon-font ${subMenu.icon}`" v-if="subMenu.icon"></i>
                      <i class="svg" v-else-if="subMenu.embed" v-html="subMenu.embed"></i>
                      <span class="sr-only">{{ subMenu.title }}</span>
                    </router-link>
                    <button :key="jindex" class="menu btn btn-light" v-b-tooltip.hover.right="{
                      customClass: 'primary-tooltip',
                    }" :title="subMenu.title" v-else>
                      <i :class="`icon-font ${subMenu.icon}`" v-if="subMenu.icon"></i>
                      <i class="svg" v-else-if="subMenu.embed" v-html="subMenu.embed"></i>
                      <span class="sr-only">{{ subMenu.title }}</span>
                    </button>
                  </template>
                </template>
              </b-collapse>
            </div>
            <router-link :key="index" :to="menu.link" class="menu btn" :class="{ active: menu.link === currentRoute }"
              v-b-tooltip.hover.right="{ customClass: 'primary-tooltip' }" :title="menu.title" v-else-if="menu.link">
              <i :class="`icon-font ${menu.icon}`" v-if="menu.icon"></i>
              <i class="svg" v-else-if="menu.embed" v-html="menu.embed"></i>
              <span class="sr-only">{{ menu.title }}</span>
            </router-link>
            <button :key="index" class="menu btn btn-light" v-b-tooltip.hover.right="{ customClass: 'primary-tooltip' }"
              :title="menu.title" v-else>
              <i :class="`icon-font ${menu.icon}`" v-if="menu.icon"></i>
              <i class="svg" v-else-if="menu.embed" v-html="menu.embed"></i>
              <span class="sr-only">{{ menu.title }}</span>
            </button>
          </template>
        </template>
      </scrollbar>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import RCSService from '@/services/rcs.service';
import WhatsAppService from '@/services/whatsapp.service';
import Permissions from '@/router/permissions';

export default {
  name: 'Sidebar',
  computed: {
    hasAccordion() {
      console.log('hasAccordion', new Date());

      const accordions = this.accordions;

      if (!accordions || !accordions.length) return false;

      return accordions.some((accordion) => accordion === true);
    },
    account() {
      return this.$store.state.account;
    },
    whitelabelId() {
      return this?.account?.['whitelabel_id'];
    },
    // currentRoute() {
    //   return this.$router?.currentRoute?.path || '';
    // },
  },
  mounted() {
    // this.checkLive();
    this.$live.setup(this);

    this.$root.$on('live:notify', (enable) => {
      // console.log('emitLiveNotification', enable);

      if (enable) {
        this.emitLiveNotification();
      } else {
        this.hasNotification = false;
      }
    });

    setTimeout(() => this.checkClient(), 1);
  },
  data() {
    return {
      currentRoute: this.$router?.currentRoute?.path,
      audioEnabled: false,
      audioIssue: false,

      updateScrollBarTimeout: 0,
      accordions: {},
      alternativeAccordions: {},
      available: {
        whatsapp: false,
        rcs: false,
      },
      items: [
        // {
        //   title: 'Dashboard',
        //   link: '/',
        //   icon: 'fab fa-whatsapp',
        // },
        // {
        //   title: 'Dashboard',
        //   icon: 'fab fa-whatsapp',
        // },
        {
          title: 'Dashboard',
          link: '/',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
          <path id="dashboard_FILL0_wght400_GRAD0_opsz48" d="M16.292,12.333V6.792A.767.767,0,0,1,17.083,6h7.125A.767.767,0,0,1,25,6.792v5.542a.767.767,0,0,1-.792.792H17.083a.767.767,0,0,1-.792-.792ZM6,15.5V6.792A.767.767,0,0,1,6.792,6h7.125a.767.767,0,0,1,.792.792V15.5a.767.767,0,0,1-.792.792H6.792A.767.767,0,0,1,6,15.5Zm10.292,8.708V15.5a.767.767,0,0,1,.792-.792h7.125A.767.767,0,0,1,25,15.5v8.708a.767.767,0,0,1-.792.792H17.083a.767.767,0,0,1-.792-.792ZM6,24.208V18.667a.767.767,0,0,1,.792-.792h7.125a.767.767,0,0,1,.792.792v5.542a.767.767,0,0,1-.792.792H6.792A.767.767,0,0,1,6,24.208Zm1.583-9.5h5.542V7.583H7.583Zm10.292,8.708h5.542V16.292H17.875Zm0-11.875h5.542V7.583H17.875ZM7.583,23.417h5.542V19.458H7.583ZM13.125,14.708ZM17.875,11.542ZM17.875,16.292ZM13.125,19.458Z" transform="translate(-6 -6)"/>
          </svg>`,
        },
        {
          title: 'SMS',
          scope: 'sms',
          embed: `<svg id="SMS" xmlns="http://www.w3.org/2000/svg" width="19" height="18.005" viewBox="0 0 19 18.005">
          <path id="sms_FILL0_wght400_GRAD0_opsz48" d="M4,21.29V5.425a1.38,1.38,0,0,1,.427-.986,1.35,1.35,0,0,1,1-.439h16.15a1.363,1.363,0,0,1,.986.439A1.363,1.363,0,0,1,23,5.425v12.35A1.507,1.507,0,0,1,21.575,19.2H7.8L5.211,21.789a.659.659,0,0,1-.772.154A.651.651,0,0,1,4,21.29Zm1.425-1.734,1.781-1.781H21.575V5.425H5.425Zm0-14.131h0v12.35h0V5.425Z" transform="translate(-4 -4)"/>
          <path id="Path_1243" data-name="Path 1243" d="M.287-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,1.756-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135A.336.336,0,0,0,2.156-1.1a.364.364,0,0,0-.07-.22.757.757,0,0,0-.192-.179,2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5A1.094,1.094,0,0,1,.27-3.023,1.139,1.139,0,0,1,.4-3.587,1.12,1.12,0,0,1,.76-3.976,1.609,1.609,0,0,1,1.286-4.2a2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59A1.082,1.082,0,0,1,2.657-.2a1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,.828.015,1.985,1.985,0,0,1,.287-.161ZM8.631,0H7.7V-2.514q0-.407.035-.9H7.708a4.426,4.426,0,0,1-.132.557L6.592,0H5.818l-1-2.827a5.5,5.5,0,0,1-.132-.586H4.658q.038.621.038,1.09V0H3.844V-4.2H5.229l.858,2.49a3.506,3.506,0,0,1,.149.6h.018a6.047,6.047,0,0,1,.167-.606L7.28-4.2H8.631Zm.762-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,10.862-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135.336.336,0,0,0,.044-.168.364.364,0,0,0-.07-.22A.757.757,0,0,0,11-1.494a2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5,1.094,1.094,0,0,1-.242-.715,1.139,1.139,0,0,1,.132-.564,1.12,1.12,0,0,1,.359-.388,1.609,1.609,0,0,1,.526-.224,2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59,1.082,1.082,0,0,1-.362.387,1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,9.933.015,1.985,1.985,0,0,1,9.393-.161Z" transform="translate(3 9)"/>
          </svg>`,
          subItems: [
            {
              title: 'Enviar SMS',
              link: '/sms/send',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.019" viewBox="0 0 19 19.019">
              <path id="paper-plane-regular" d="M18.633.156a.9.9,0,0,0-.945-.039L.45,9.922a.892.892,0,0,0,.1,1.6L6.241,13.91v4.216a.892.892,0,0,0,.464.782.859.859,0,0,0,.394.11.9.9,0,0,0,.483-.142l4.131-2.654,3.661,1.538A.891.891,0,0,0,16.6,17.07L18.977,1.023A.819.819,0,0,0,18.633.156ZM13.718,4.428l-6.95,7.76L2.906,10.576ZM7.99,16.493V14.66l1.725.725Zm7.047-.821-6.56-2.756L16.82,3.648Z" transform="translate(0 0)"/>
              </svg>`,
            },
            {
              title: 'Templates',
              link: '/sms/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Relatório de uso',
              link: '/sms/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
            {
              title: 'Deny List e OPT-Outs',
              link: '/sms/denylist',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="icon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="person_off_FILL0_wght300_GRAD0_opsz48" d="M20.389,23.111l.195.286H7.719a.726.726,0,0,1-.542-.211.757.757,0,0,1-.207-.553V21.394a2.523,2.523,0,0,1,.439-1.476,2.937,2.937,0,0,1,1.137-.975,17.531,17.531,0,0,1,3.009-1.081,12.775,12.775,0,0,1,2.906-.4h.155a.745.745,0,0,1,.181.026L4.981,7.478a.582.582,0,0,1,0-.843.585.585,0,0,1,.852,0L21.241,22.267a.606.606,0,0,1,.168.409.557.557,0,0,1-.168.435.585.585,0,0,1-.852,0Zm-12.256-.9H19.421l-3.41-3.479a4.985,4.985,0,0,0-.633-.066q-.323-.013-.659-.013a13.045,13.045,0,0,0-2.8.3,12.058,12.058,0,0,0-2.88,1.067,1.826,1.826,0,0,0-.646.593,1.375,1.375,0,0,0-.258.778Zm12.942-3.136a1.841,1.841,0,0,1,.8.659,1.807,1.807,0,0,1,.31,1.054v.158l-2.3-2.346q.284.105.581.224T21.074,19.075ZM16.4,14.963l-.93-.949a2.2,2.2,0,0,0,1.085-.817,2.372,2.372,0,0,0-.232-2.965,2.132,2.132,0,0,0-1.6-.672,2.108,2.108,0,0,0-1.317.435,2.316,2.316,0,0,0-.8,1.12l-.9-.949A3.091,3.091,0,0,1,12.95,8.835a3.528,3.528,0,0,1,1.769-.461,3.285,3.285,0,0,1,2.441,1.015,3.39,3.39,0,0,1,.995,2.464,3.684,3.684,0,0,1-.465,1.832A3.2,3.2,0,0,1,16.4,14.963Zm3.022,7.248h0ZM14.048,12.538Z" transform="translate(15.2 134.35)"/>
              </g>
              </svg>`,
            },
            {
              title: 'Short Codes',
              link: '/sms/short-codes',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="22.2" height="17.761" viewBox="0 0 22.2 17.761">
              <path id="code-solid" d="M14.389,1.407,9.949,16.948a1.111,1.111,0,0,1-2.137-.611L12.252.8a1.111,1.111,0,0,1,2.137.61Zm3.6,2.8,3.885,3.885a1.108,1.108,0,0,1,0,1.568l-3.885,3.885a1.109,1.109,0,0,1-1.568-1.568l3.1-3.1-3.1-3.1A1.109,1.109,0,0,1,17.989,4.2ZM5.779,5.772l-3.1,3.1,3.1,3.1a1.109,1.109,0,0,1-1.568,1.568L.325,9.657a1.108,1.108,0,0,1,0-1.568L4.211,4.2A1.109,1.109,0,0,1,5.779,5.772Z" transform="translate(0 0.008)"/>
              </svg>`,
            },
            {
              title: 'Usuários SMPP',
              link: '/sms/smpp',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="ICon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="Path_958" data-name="Path 958" d="M.239-.134V-.916A1.5,1.5,0,0,0,.7-.648a1.483,1.483,0,0,0,.5.089,1.115,1.115,0,0,0,.26-.027A.609.609,0,0,0,1.649-.66.325.325,0,0,0,1.76-.773.28.28,0,0,0,1.8-.913.3.3,0,0,0,1.738-1.1a.631.631,0,0,0-.16-.149,1.671,1.671,0,0,0-.24-.132q-.139-.063-.3-.129a1.533,1.533,0,0,1-.612-.417.911.911,0,0,1-.2-.6.949.949,0,0,1,.11-.47.933.933,0,0,1,.3-.323A1.341,1.341,0,0,1,1.072-3.5,2.252,2.252,0,0,1,1.6-3.56a3.172,3.172,0,0,1,.485.033,1.906,1.906,0,0,1,.389.1v.73A1.177,1.177,0,0,0,2.281-2.8a1.518,1.518,0,0,0-.214-.077,1.629,1.629,0,0,0-.219-.045,1.546,1.546,0,0,0-.206-.015,1.076,1.076,0,0,0-.244.026.626.626,0,0,0-.186.072.358.358,0,0,0-.117.111.263.263,0,0,0-.042.145.277.277,0,0,0,.046.157.532.532,0,0,0,.132.132,1.4,1.4,0,0,0,.208.122q.122.06.276.123a3.074,3.074,0,0,1,.377.187,1.341,1.341,0,0,1,.287.223.87.87,0,0,1,.183.284,1,1,0,0,1,.063.372,1,1,0,0,1-.111.492.9.9,0,0,1-.3.322,1.307,1.307,0,0,1-.443.177,2.561,2.561,0,0,1-.533.054A2.966,2.966,0,0,1,.69.012,1.655,1.655,0,0,1,.239-.134ZM7.192,0H6.414V-2.095q0-.339.029-.75h-.02a3.688,3.688,0,0,1-.11.464L5.493,0H4.849L4.014-2.356a4.585,4.585,0,0,1-.11-.488H3.882q.032.518.032.908V0H3.2V-3.5H4.358l.715,2.075a2.922,2.922,0,0,1,.125.5h.015a5.04,5.04,0,0,1,.139-.505L6.067-3.5H7.192ZM8.777-1.206V0H7.988V-3.5H9.224q1.323,0,1.323,1.116a1.071,1.071,0,0,1-.38.853,1.5,1.5,0,0,1-1.014.326Zm0-1.689V-1.8h.31q.63,0,.63-.552t-.63-.54Zm3.071,1.689V0H11.06V-3.5h1.235q1.323,0,1.323,1.116a1.071,1.071,0,0,1-.38.853,1.5,1.5,0,0,1-1.014.326Zm0-1.689V-1.8h.31q.63,0,.63-.552t-.63-.54Z" transform="translate(22.579 150.035)"/>
              </g>
              </svg>`,
            },
          ],
        },
        {
          permissions: 'whatsapp',
          title: 'WhatsApp',
          icon: 'fab fa-whatsapp',
          scope: 'whatsapp',
          subItems: [
            {
              title: 'Enviar WhatsApp',
              link: '/whatsapp/send',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.019" viewBox="0 0 19 19.019">
              <path id="paper-plane-regular" d="M18.633.156a.9.9,0,0,0-.945-.039L.45,9.922a.892.892,0,0,0,.1,1.6L6.241,13.91v4.216a.892.892,0,0,0,.464.782.859.859,0,0,0,.394.11.9.9,0,0,0,.483-.142l4.131-2.654,3.661,1.538A.891.891,0,0,0,16.6,17.07L18.977,1.023A.819.819,0,0,0,18.633.156ZM13.718,4.428l-6.95,7.76L2.906,10.576ZM7.99,16.493V14.66l1.725.725Zm7.047-.821-6.56-2.756L16.82,3.648Z" transform="translate(0 0)"/>
              </svg>`,
            },
            {
              title: 'Templates',
              link: '/whatsapp/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Relatório de uso',
              link: '/whatsapp/reports/history',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
            {
              title: 'Deny List e OPT-Outs',
              link: '/whatsapp/denylist',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="icon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="person_off_FILL0_wght300_GRAD0_opsz48" d="M20.389,23.111l.195.286H7.719a.726.726,0,0,1-.542-.211.757.757,0,0,1-.207-.553V21.394a2.523,2.523,0,0,1,.439-1.476,2.937,2.937,0,0,1,1.137-.975,17.531,17.531,0,0,1,3.009-1.081,12.775,12.775,0,0,1,2.906-.4h.155a.745.745,0,0,1,.181.026L4.981,7.478a.582.582,0,0,1,0-.843.585.585,0,0,1,.852,0L21.241,22.267a.606.606,0,0,1,.168.409.557.557,0,0,1-.168.435.585.585,0,0,1-.852,0Zm-12.256-.9H19.421l-3.41-3.479a4.985,4.985,0,0,0-.633-.066q-.323-.013-.659-.013a13.045,13.045,0,0,0-2.8.3,12.058,12.058,0,0,0-2.88,1.067,1.826,1.826,0,0,0-.646.593,1.375,1.375,0,0,0-.258.778Zm12.942-3.136a1.841,1.841,0,0,1,.8.659,1.807,1.807,0,0,1,.31,1.054v.158l-2.3-2.346q.284.105.581.224T21.074,19.075ZM16.4,14.963l-.93-.949a2.2,2.2,0,0,0,1.085-.817,2.372,2.372,0,0,0-.232-2.965,2.132,2.132,0,0,0-1.6-.672,2.108,2.108,0,0,0-1.317.435,2.316,2.316,0,0,0-.8,1.12l-.9-.949A3.091,3.091,0,0,1,12.95,8.835a3.528,3.528,0,0,1,1.769-.461,3.285,3.285,0,0,1,2.441,1.015,3.39,3.39,0,0,1,.995,2.464,3.684,3.684,0,0,1-.465,1.832A3.2,3.2,0,0,1,16.4,14.963Zm3.022,7.248h0ZM14.048,12.538Z" transform="translate(15.2 134.35)"/>
              </g>
              </svg>`,
            },
          ],
        },
        {
          permissions: 'whatsapp',
          title: 'WhatsApp Meta',
          icon: 'fab fa-whatsapp',
          scope: 'whatsapp/jv',
          subItems: [
            {
              title: 'Enviar WhatsApp',
              link: '/whatsapp/jv/send',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.019" viewBox="0 0 19 19.019">
              <path id="paper-plane-regular" d="M18.633.156a.9.9,0,0,0-.945-.039L.45,9.922a.892.892,0,0,0,.1,1.6L6.241,13.91v4.216a.892.892,0,0,0,.464.782.859.859,0,0,0,.394.11.9.9,0,0,0,.483-.142l4.131-2.654,3.661,1.538A.891.891,0,0,0,16.6,17.07L18.977,1.023A.819.819,0,0,0,18.633.156ZM13.718,4.428l-6.95,7.76L2.906,10.576ZM7.99,16.493V14.66l1.725.725Zm7.047-.821-6.56-2.756L16.82,3.648Z" transform="translate(0 0)"/>
              </svg>`,
            },
            {
              title: 'Templates',
              link: '/whatsapp/jv/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Relatório de uso',
              link: '/whatsapp/jv/reports/history',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
            {
              title: 'Deny List e OPT-Outs',
              link: '/whatsapp/jv/denylist',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="icon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="person_off_FILL0_wght300_GRAD0_opsz48" d="M20.389,23.111l.195.286H7.719a.726.726,0,0,1-.542-.211.757.757,0,0,1-.207-.553V21.394a2.523,2.523,0,0,1,.439-1.476,2.937,2.937,0,0,1,1.137-.975,17.531,17.531,0,0,1,3.009-1.081,12.775,12.775,0,0,1,2.906-.4h.155a.745.745,0,0,1,.181.026L4.981,7.478a.582.582,0,0,1,0-.843.585.585,0,0,1,.852,0L21.241,22.267a.606.606,0,0,1,.168.409.557.557,0,0,1-.168.435.585.585,0,0,1-.852,0Zm-12.256-.9H19.421l-3.41-3.479a4.985,4.985,0,0,0-.633-.066q-.323-.013-.659-.013a13.045,13.045,0,0,0-2.8.3,12.058,12.058,0,0,0-2.88,1.067,1.826,1.826,0,0,0-.646.593,1.375,1.375,0,0,0-.258.778Zm12.942-3.136a1.841,1.841,0,0,1,.8.659,1.807,1.807,0,0,1,.31,1.054v.158l-2.3-2.346q.284.105.581.224T21.074,19.075ZM16.4,14.963l-.93-.949a2.2,2.2,0,0,0,1.085-.817,2.372,2.372,0,0,0-.232-2.965,2.132,2.132,0,0,0-1.6-.672,2.108,2.108,0,0,0-1.317.435,2.316,2.316,0,0,0-.8,1.12l-.9-.949A3.091,3.091,0,0,1,12.95,8.835a3.528,3.528,0,0,1,1.769-.461,3.285,3.285,0,0,1,2.441,1.015,3.39,3.39,0,0,1,.995,2.464,3.684,3.684,0,0,1-.465,1.832A3.2,3.2,0,0,1,16.4,14.963Zm3.022,7.248h0ZM14.048,12.538Z" transform="translate(15.2 134.35)"/>
              </g>
              </svg>`,
            },
            {
              title: 'Telefones',
              link: '/whatsapp/jv/numbers',
              embed: `<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 6H10V8H8V6ZM12 6H14V8H12V6ZM17 12.5C15.75 12.5 14.55 12.3 13.43 11.93C13.33 11.9 13.22 11.88 13.12 11.88C12.86 11.88 12.61 11.98 12.41 12.17L10.21 14.37C7.38 12.93 5.06 10.62 3.62 7.79L5.82 5.58C6.1 5.31 6.18 4.92 6.07 4.57C5.7 3.45 5.5 2.25 5.5 1C5.5 0.45 5.05 0 4.5 0H1C0.45 0 0 0.45 0 1C0 10.39 7.61 18 17 18C17.55 18 18 17.55 18 17V13.5C18 12.95 17.55 12.5 17 12.5ZM2.03 2H3.53C3.6 2.88 3.75 3.75 3.99 4.59L2.79 5.8C2.38 4.59 2.12 3.32 2.03 2ZM16 15.97C14.68 15.88 13.4 15.62 12.2 15.21L13.4 14.01C14.25 14.25 15.12 14.4 16 14.46V15.97ZM16 6H18V8H16V6Z"/>
              </svg>`,
            },
          ],
        },
        {
          permissions: 'rcs',
          title: 'Google RCS',
          icon: 'fab fa-google',
          scope: 'rcs',
          subItems: [
            {
              title: 'Enviar RCS',
              link: '/rcs/send',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.019" viewBox="0 0 19 19.019">
              <path id="paper-plane-regular" d="M18.633.156a.9.9,0,0,0-.945-.039L.45,9.922a.892.892,0,0,0,.1,1.6L6.241,13.91v4.216a.892.892,0,0,0,.464.782.859.859,0,0,0,.394.11.9.9,0,0,0,.483-.142l4.131-2.654,3.661,1.538A.891.891,0,0,0,16.6,17.07L18.977,1.023A.819.819,0,0,0,18.633.156ZM13.718,4.428l-6.95,7.76L2.906,10.576ZM7.99,16.493V14.66l1.725.725Zm7.047-.821-6.56-2.756L16.82,3.648Z" transform="translate(0 0)"/>
              </svg>`,
            },
            {
              title: 'Templates',
              link: '/rcs/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            // {
            //   title: 'Templates',
            //   link: '/rcs/templates',
            //   permissions: 'yupchat',
            //   embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
            //   <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
            //   </svg>`,
            // },
            {
              title: 'Relatório de uso',
              link: '/rcs/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
            {
              title: 'Deny List e OPT-Outs',
              link: '/rcs/denylist',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="icon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="person_off_FILL0_wght300_GRAD0_opsz48" d="M20.389,23.111l.195.286H7.719a.726.726,0,0,1-.542-.211.757.757,0,0,1-.207-.553V21.394a2.523,2.523,0,0,1,.439-1.476,2.937,2.937,0,0,1,1.137-.975,17.531,17.531,0,0,1,3.009-1.081,12.775,12.775,0,0,1,2.906-.4h.155a.745.745,0,0,1,.181.026L4.981,7.478a.582.582,0,0,1,0-.843.585.585,0,0,1,.852,0L21.241,22.267a.606.606,0,0,1,.168.409.557.557,0,0,1-.168.435.585.585,0,0,1-.852,0Zm-12.256-.9H19.421l-3.41-3.479a4.985,4.985,0,0,0-.633-.066q-.323-.013-.659-.013a13.045,13.045,0,0,0-2.8.3,12.058,12.058,0,0,0-2.88,1.067,1.826,1.826,0,0,0-.646.593,1.375,1.375,0,0,0-.258.778Zm12.942-3.136a1.841,1.841,0,0,1,.8.659,1.807,1.807,0,0,1,.31,1.054v.158l-2.3-2.346q.284.105.581.224T21.074,19.075ZM16.4,14.963l-.93-.949a2.2,2.2,0,0,0,1.085-.817,2.372,2.372,0,0,0-.232-2.965,2.132,2.132,0,0,0-1.6-.672,2.108,2.108,0,0,0-1.317.435,2.316,2.316,0,0,0-.8,1.12l-.9-.949A3.091,3.091,0,0,1,12.95,8.835a3.528,3.528,0,0,1,1.769-.461,3.285,3.285,0,0,1,2.441,1.015,3.39,3.39,0,0,1,.995,2.464,3.684,3.684,0,0,1-.465,1.832A3.2,3.2,0,0,1,16.4,14.963Zm3.022,7.248h0ZM14.048,12.538Z" transform="translate(15.2 134.35)"/>
              </g>
              </svg>`,
            },
            {
              title: 'Agentes',
              link: '/rcs/agents',
              embed: '<span class="material-icons-outlined">widgets</span>',
            },
          ],
        },
        {
          title: 'E-mail',
          scope: 'mail',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="15.2" viewBox="0 0 19 15.2">
          <path id="mail_FILL0_wght400_GRAD0_opsz48" d="M5.425,23.2A1.461,1.461,0,0,1,4,21.775V9.425A1.461,1.461,0,0,1,5.425,8h16.15A1.461,1.461,0,0,1,23,9.425v12.35A1.461,1.461,0,0,1,21.575,23.2Zm16.15-12.469-7.7,5.035q-.1.048-.178.083a.59.59,0,0,1-.4,0q-.083-.036-.178-.083L5.425,10.731V21.775h16.15ZM13.5,14.6l7.98-5.177H5.544ZM5.425,10.731V21.775h0Z" transform="translate(-4 -8)"/>
          </svg>`,
          subItems: [
            {
              title: 'Enviar e-mail',
              link: '/mail/send',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.019" viewBox="0 0 19 19.019">
              <path id="paper-plane-regular" d="M18.633.156a.9.9,0,0,0-.945-.039L.45,9.922a.892.892,0,0,0,.1,1.6L6.241,13.91v4.216a.892.892,0,0,0,.464.782.859.859,0,0,0,.394.11.9.9,0,0,0,.483-.142l4.131-2.654,3.661,1.538A.891.891,0,0,0,16.6,17.07L18.977,1.023A.819.819,0,0,0,18.633.156ZM13.718,4.428l-6.95,7.76L2.906,10.576ZM7.99,16.493V14.66l1.725.725Zm7.047-.821-6.56-2.756L16.82,3.648Z" transform="translate(0 0)"/>
              </svg>`,
            },
            {
              title: 'Templates',
              link: '/mail/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Relatório de uso',
              link: '/mail/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
            {
              title: 'Deny List e OPT-Outs',
              link: '/mail/denylist',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <g id="icon" transform="translate(-20 -138.786)">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(13 131.786)"/>
              <path id="person_off_FILL0_wght300_GRAD0_opsz48" d="M20.389,23.111l.195.286H7.719a.726.726,0,0,1-.542-.211.757.757,0,0,1-.207-.553V21.394a2.523,2.523,0,0,1,.439-1.476,2.937,2.937,0,0,1,1.137-.975,17.531,17.531,0,0,1,3.009-1.081,12.775,12.775,0,0,1,2.906-.4h.155a.745.745,0,0,1,.181.026L4.981,7.478a.582.582,0,0,1,0-.843.585.585,0,0,1,.852,0L21.241,22.267a.606.606,0,0,1,.168.409.557.557,0,0,1-.168.435.585.585,0,0,1-.852,0Zm-12.256-.9H19.421l-3.41-3.479a4.985,4.985,0,0,0-.633-.066q-.323-.013-.659-.013a13.045,13.045,0,0,0-2.8.3,12.058,12.058,0,0,0-2.88,1.067,1.826,1.826,0,0,0-.646.593,1.375,1.375,0,0,0-.258.778Zm12.942-3.136a1.841,1.841,0,0,1,.8.659,1.807,1.807,0,0,1,.31,1.054v.158l-2.3-2.346q.284.105.581.224T21.074,19.075ZM16.4,14.963l-.93-.949a2.2,2.2,0,0,0,1.085-.817,2.372,2.372,0,0,0-.232-2.965,2.132,2.132,0,0,0-1.6-.672,2.108,2.108,0,0,0-1.317.435,2.316,2.316,0,0,0-.8,1.12l-.9-.949A3.091,3.091,0,0,1,12.95,8.835a3.528,3.528,0,0,1,1.769-.461,3.285,3.285,0,0,1,2.441,1.015,3.39,3.39,0,0,1,.995,2.464,3.684,3.684,0,0,1-.465,1.832A3.2,3.2,0,0,1,16.4,14.963Zm3.022,7.248h0ZM14.048,12.538Z" transform="translate(15.2 134.35)"/>
              </g>
              </svg>`,
            },
            {
              title: 'Dominios de e-mail',
              link: '/mail/domains',
              embed:
                '<span class="material-icons-outlined">alternate_email</span>',
            },
          ],
        },
        {
          title: 'Encurtador de URL',
          scope: 'LinksList',
          embed: '<span class="material-symbols-outlined">link</span>',
          subItems: [
            {
              title: 'Links',
              link: '/shortener/links',
              embed: '<span class="material-symbols-outlined">add_link</span>',
            },
            /* {
              title: 'Relatórios',
              link: '/shortener/reports',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            }, */
          ],
        },
        /*
        {
          title: 'Contatos',
          scope: 'contacts',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="20.267" viewBox="0 0 19 20.267">
          <path id="address-book-regular" d="M41.5,11.4H38.967A3.166,3.166,0,0,0,35.8,14.567a.635.635,0,0,0,.633.633h7.6a.633.633,0,0,0,.633-.633A3.166,3.166,0,0,0,41.5,11.4Zm-1.267-1.267A2.533,2.533,0,1,0,37.7,7.6,2.533,2.533,0,0,0,40.233,10.133Zm10.133,2.533h-.633v3.8h.633A.633.633,0,0,0,51,15.833V13.3A.635.635,0,0,0,50.367,12.667Zm0-10.133h-.633v3.8h.633A.635.635,0,0,0,51,5.7V3.167A.634.634,0,0,0,50.367,2.533Zm0,5.067h-.633v3.8h.633A.635.635,0,0,0,51,10.767V8.233A.635.635,0,0,0,50.367,7.6ZM45.933,0h-11.4A2.533,2.533,0,0,0,32,2.533v15.2a2.533,2.533,0,0,0,2.533,2.533h11.4a2.533,2.533,0,0,0,2.533-2.533V2.533A2.534,2.534,0,0,0,45.933,0Zm.633,17.733a.633.633,0,0,1-.633.633h-11.4a.633.633,0,0,1-.633-.633V2.533a.633.633,0,0,1,.633-.633h11.4a.633.633,0,0,1,.633.633Z" transform="translate(-32)"/>
          </svg>`,
          subItems: [
            {
              title: 'Lista',
              link: '/contacts',
              embed: '<span class="material-icons-outlined">person</span>',
            },
            {
              title: 'Grupos',
              link: '/contacts/groups',
              embed: '<span class="material-icons-outlined">groups</span>',
            },
            {
              title: 'Importar',
              link: '/contacts/import',
              embed: '<span class="material-icons-outlined">file_upload</span>',
            },
          ],
        },
        */
        {
          title: 'Contatos',
          link: '/contacts',
          embed: '<span class="material-icons-outlined">contact_page</span>',
        },
        {
          title: 'Lookup',
          link: '/lookup',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.597" viewBox="0 0 19 19.597">
            <g id="phone_verification" data-name="phone verification" transform="translate(0)">
              <path id="phone_callback_FILL0_wght400_GRAD0_opsz48" d="M22.75,23.92a13.426,13.426,0,0,1-6.036-1.493,20.492,20.492,0,0,1-5.388-3.883,20.492,20.492,0,0,1-3.883-5.388A13.426,13.426,0,0,1,5.95,7.12,1.105,1.105,0,0,1,7.07,6h3.484a.88.88,0,0,1,.61.236,1.1,1.1,0,0,1,.336.635l.672,3.136a1.79,1.79,0,0,1-.012.635.959.959,0,0,1-.261.485L9.41,13.641a20.664,20.664,0,0,0,3.124,4.032,17.263,17.263,0,0,0,3.92,2.912l2.364-2.439a1.376,1.376,0,0,1,.572-.386,1.15,1.15,0,0,1,.647-.037L23,18.37a1.087,1.087,0,0,1,.871,1.07V22.8a1.105,1.105,0,0,1-1.12,1.12ZM8.663,12.272l2.016-2.041-.572-2.738H7.443a8.567,8.567,0,0,0,.3,2.128A20.062,20.062,0,0,0,8.663,12.272ZM22.377,22.427V19.764l-2.564-.523-1.966,2.066a12.422,12.422,0,0,0,2.215.772A11.681,11.681,0,0,0,22.377,22.427ZM17.847,21.307ZM8.663,12.272Z" transform="translate(-5.95 -4.323)"/>
              <path id="check_circle_FILL0_wght400_GRAD0_opsz48" d="M8.74,10.825,7.378,9.463a.416.416,0,0,0-.306-.125.476.476,0,0,0-.459.459.4.4,0,0,0,.139.306l1.7,1.7a.4.4,0,0,0,.584,0l3.336-3.336a.393.393,0,0,0,.118-.306.441.441,0,0,0-.132-.306.4.4,0,0,0-.313-.139.447.447,0,0,0-.327.139Zm.82,4.3a5.639,5.639,0,0,1-2.2-.424,5.381,5.381,0,0,1-2.94-2.94,5.865,5.865,0,0,1,0-4.379A5.426,5.426,0,0,1,5.6,5.612,5.543,5.543,0,0,1,9.56,4a5.6,5.6,0,0,1,5.129,7.756,5.519,5.519,0,0,1-1.182,1.765A5.427,5.427,0,0,1,11.742,14.7,5.6,5.6,0,0,1,9.56,15.12ZM9.56,9.56Zm0,4.726A4.631,4.631,0,0,0,14.286,9.56,4.631,4.631,0,0,0,9.56,4.834,4.631,4.631,0,0,0,4.834,9.56,4.631,4.631,0,0,0,9.56,14.286Z" transform="translate(3.88 -4)"/>
            </g>
          </svg>`,
        },

        {
          // title: 'Omni Business',
          title: 'Chat',
          scope: 'live',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.5" height="20.5" viewBox="0 0 20.5 20.5">
          <defs>
          <clipPath id="clip-path">
          <rect id="Rectangle_3311" data-name="Rectangle 3311" width="8.266" height="8.759"/>
          </clipPath>
          </defs>
          <g id="omniBusiness" transform="translate(0.75 0.75)">
          <g id="Group_12210" data-name="Group 12210" transform="translate(5.5 5)" clip-path="url(#clip-path)">
          <path id="Path_976" data-name="Path 976" d="M16.96,18.342c-1.181-2.44-2.283-4.881-3.385-7.321H12l3.306,7.321H12.945l.63,1.417h2.677Z" transform="translate(-12 -11.01)" fill-rule="evenodd"/>
          <path id="Path_977" data-name="Path 977" d="M20.345,12.516H17.353c-.236-.551-.394-1.023-.63-1.5h5.9l-2.992,6.455c-.236-.551-.472-1.1-.787-1.732C19.4,14.642,19.872,13.618,20.345,12.516Z" transform="translate(-14.362 -11.01)" fill-rule="evenodd"/>
          </g>
          <path id="Path_978" data-name="Path 978" d="M10.5,1A9.5,9.5,0,1,0,20,10.5c0-1.429-.5-4.5-2.5-6.25" transform="translate(-1 -1)" fill="none" style="stroke: currentColor" stroke-linecap="round" stroke-width="1.5"/>
          <path id="Path_979" data-name="Path 979" d="M31.3,4.55a.75.75,0,1,1-.75-.75A.75.75,0,0,1,31.3,4.55Z" transform="translate(-16.8 -3.8)" fill-rule="evenodd"/>
          </g>
          </svg>`,
          subItems: [
            {
              title: 'Monitoramento',
              link: '/live/dashboard',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="monitoring_FILL0_wght400_GRAD0_opsz48" d="M6,25V22.994l1.583-1.583V25Zm4.354,0V18.772l1.583-1.583V25Zm4.354,0V17.189l1.583,1.61V25Zm4.354,0V18.8l1.583-1.583V25Zm4.354,0V14.55L25,12.967V25ZM6,18.772V16.529l7.389-7.336,4.222,4.222L25,6V8.243l-7.389,7.415-4.222-4.222Z" transform="translate(-6 -6)"/>
              </svg>`,
            },
            {
              title: 'Widget',
              link: '/live/configs/widget',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="widgets_FILL0_wght400_GRAD0_opsz48" d="M19.758,13.884,14.516,8.642,19.758,3.4,25,8.642ZM6,12.112V4.7h7.408v7.408ZM16.288,22.4V14.992H23.7V22.4ZM6,22.4V14.992h7.408V22.4ZM7.477,10.636h4.455V6.181H7.477Zm12.355,1.255,3.175-3.175L19.832,5.541,16.657,8.716Zm-2.067,9.032h4.455V16.469H17.764Zm-10.288,0h4.455V16.469H7.477ZM11.931,10.636ZM16.657,8.716ZM11.931,16.469ZM17.764,16.469Z" transform="translate(-6 -3.4)"/>
              </svg>`,
            },
            {
              title: 'Atendimento',
              link: '/live',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="headset-solid" d="M7.092,8.313A1.188,1.188,0,0,0,5.9,7.124h-.56A2.376,2.376,0,0,0,2.969,9.5v1.773a2.378,2.378,0,0,0,2.375,2.38h.594a1.189,1.189,0,0,0,1.188-1.19ZM9.5,0A9.679,9.679,0,0,0,0,9.5v1.484a.883.883,0,0,0,.857.891.942.942,0,0,0,.924-.891V9.5a7.719,7.719,0,0,1,15.438,0v5.344a1.484,1.484,0,0,1-1.484,1.484H11.626a1.77,1.77,0,0,0-1.533-.891H8.973A1.825,1.825,0,0,0,7.16,16.866,1.777,1.777,0,0,0,8.873,19h1.221a1.773,1.773,0,0,0,1.534-.891h4.107A3.266,3.266,0,0,0,19,14.844V9.5A9.681,9.681,0,0,0,9.5,0Zm4.156,13.656a2.377,2.377,0,0,0,2.375-2.38V9.5a2.378,2.378,0,0,0-2.375-2.379h-.594a1.188,1.188,0,0,0-1.187,1.189v4.151a1.187,1.187,0,0,0,1.188,1.191Z"/>
              </svg>`,
            },
            {
              title: 'Agentes',
              link: '/live/manage',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19.5" height="17.194" viewBox="0 0 19.5 17.194">
              <g id="spy" transform="translate(0.25)">
              <g id="Group_12717" data-name="Group 12717" transform="translate(0)">
              <path id="Path_1231" data-name="Path 1231" d="M18.514,45.179a39.7,39.7,0,0,1-2.046-5.9,1.213,1.213,0,0,0-1.184-.963H12.441a1.211,1.211,0,0,0-1.21,1.21v.365H7.768V39.53a1.211,1.211,0,0,0-1.21-1.21H3.716a1.213,1.213,0,0,0-1.184.963,39.7,39.7,0,0,1-2.046,5.9A6.248,6.248,0,0,0,0,47.6v3.2a1.211,1.211,0,0,0,1.21,1.21H6.559a1.211,1.211,0,0,0,1.21-1.21V44.579h3.463V50.8a1.211,1.211,0,0,0,1.21,1.21H17.79A1.211,1.211,0,0,0,19,50.8V47.6A6.248,6.248,0,0,0,18.514,45.179ZM6.919,50.8a.36.36,0,0,1-.36.36H1.21a.361.361,0,0,1-.36-.36V47.6a5.4,5.4,0,0,1,.42-2.094,40.386,40.386,0,0,0,2.095-6.052.359.359,0,0,1,.352-.285H6.559a.361.361,0,0,1,.36.36Zm11.232,0a.361.361,0,0,1-.36.36H12.441a.36.36,0,0,1-.36-.36V39.53a.361.361,0,0,1,.36-.36h2.842a.359.359,0,0,1,.352.285,40.385,40.385,0,0,0,2.095,6.052,5.4,5.4,0,0,1,.42,2.094v3.2Z" transform="translate(0 -35.065)" stroke="#9ca7b0" stroke-width="0.5"/>
              <path id="Path_1232" data-name="Path 1232" d="M37.7,0h2.841a.532.532,0,0,1,.532.532v1h-3.9v-1A.532.532,0,0,1,37.7,0Z" transform="translate(-34.013)"/>
              <path id="Path_1233" data-name="Path 1233" d="M143.921,0h2.841a.532.532,0,0,1,.532.532v1h-3.9v-1A.532.532,0,0,1,143.922,0Z" transform="translate(-131.21)"/>
              </g>
              </g>
              </svg>`,
            },
            {
              title: 'Ajustes do sistema',
              link: '/live/configs/system',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="25.958" height="23.236" viewBox="0 0 25.958 23.236">
              <path id="system_settigns" data-name="system settigns" d="M-315.754,652.262a.445.445,0,0,1-.3-.113.474.474,0,0,1-.16-.272l-.224-1.532a4.027,4.027,0,0,1-.711-.328,3.967,3.967,0,0,1-.647-.456l-1.4.655a.507.507,0,0,1-.344.008.469.469,0,0,1-.263-.216l-.863-1.533a.4.4,0,0,1-.048-.327.455.455,0,0,1,.191-.263l1.279-.959a2.972,2.972,0,0,1-.048-.359c-.011-.133-.016-.258-.016-.375s0-.227.016-.36a3.651,3.651,0,0,1,.048-.376l-1.279-.958a.458.458,0,0,1-.191-.264.4.4,0,0,1,.048-.327l.863-1.518a.518.518,0,0,1,.263-.224.391.391,0,0,1,.327.017l1.406.638a4.392,4.392,0,0,1,.655-.447,4.045,4.045,0,0,1,.7-.32l.239-1.549a.481.481,0,0,1,.16-.272.444.444,0,0,1,.3-.112h1.724a.453.453,0,0,1,.3.112.464.464,0,0,1,.168.272l.223,1.549a5.633,5.633,0,0,1,.711.32,2.909,2.909,0,0,1,.631.447l1.437-.638a.414.414,0,0,1,.327-.025.481.481,0,0,1,.264.216l.863,1.518a.44.44,0,0,1,.056.335.414.414,0,0,1-.2.272l-1.294.942c.022.127.038.256.048.383s.017.25.017.368-.006.224-.017.351-.026.262-.048.4l1.294.943a.417.417,0,0,1,.183.263.419.419,0,0,1-.056.327l-.862,1.533a.471.471,0,0,1-.264.216.408.408,0,0,1-.327-.023l-1.422-.639a5.5,5.5,0,0,1-.639.456,2.705,2.705,0,0,1-.7.311l-.223,1.549a.458.458,0,0,1-.168.272.454.454,0,0,1-.3.113Zm-.431-7.348a1.74,1.74,0,0,0-.527,1.279,1.736,1.736,0,0,0,.527,1.277,1.736,1.736,0,0,0,1.277.528,1.736,1.736,0,0,0,1.277-.528,1.736,1.736,0,0,0,.527-1.277,1.74,1.74,0,0,0-.527-1.279,1.739,1.739,0,0,0-1.277-.526A1.739,1.739,0,0,0-316.185,644.914Zm-9.911,3.178a1.743,1.743,0,0,1-1.343-.642,1.809,1.809,0,0,1-.377-1.5A1.823,1.823,0,0,1-326,644.517h1.124a1.765,1.765,0,0,1,1.538.894h1.41a7.585,7.585,0,0,0-.056.921,7.479,7.479,0,0,0,.05.866h-1.4a1.792,1.792,0,0,1-1.539.894Zm4.2-5.362a1.2,1.2,0,0,1-1.192-1.2v-4.165a1.2,1.2,0,0,1,1.192-1.194h.6a2.387,2.387,0,0,1,2.383,2.387v1.745a7.52,7.52,0,0,0-2.131,2.409,2.425,2.425,0,0,1-.251.013Zm-7.746,0a2.389,2.389,0,0,1-2.384-2.388v-1.78a2.387,2.387,0,0,1,2.384-2.386h.562a1.193,1.193,0,0,1,1.191,1.193l.034,4.169a1.2,1.2,0,0,1-1.191,1.195ZM-335,640.048v-1.489a10.042,10.042,0,0,1,2.832-6.679,9.28,9.28,0,0,1,6.7-2.854,9.28,9.28,0,0,1,6.7,2.854,10.042,10.042,0,0,1,2.832,6.679v.454a7.4,7.4,0,0,0-1.788.585v-1.038a7.75,7.75,0,0,0-7.745-7.738,7.751,7.751,0,0,0-7.746,7.738v1.489a.948.948,0,0,1-.928.894A.889.889,0,0,1-335,640.048Z" transform="translate(335 -629.026)"/>
              </svg>`,
            },
            {
              title: 'Respostas do sistema',
              link: '/live/configs/responses',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23">
              <g id="respostas_do_sistema" data-name="respostas do sistema" transform="translate(4250 -2526)">
              <path id="chat_bubble_FILL0_wght400_GRAD0_opsz48" d="M4,27V5.725a1.671,1.671,0,0,1,.518-1.193A1.634,1.634,0,0,1,5.725,4h19.55a1.65,1.65,0,0,1,1.193.532A1.65,1.65,0,0,1,27,5.725v14.95A1.825,1.825,0,0,1,25.275,22.4H8.6Zm1.725-4.169,2.156-2.156H25.275V5.725H5.725Zm0-17.107v0Z" transform="translate(-4254 2522)"/>
              <path id="smart_toy_FILL0_wght400_GRAD0_opsz48" d="M3.573,11.409a1.58,1.58,0,0,1-1.117-2.69,1.519,1.519,0,0,1,1.117-.456V6.455a.9.9,0,0,1,.882-.882H6.9A1.556,1.556,0,0,1,8.468,4a1.556,1.556,0,0,1,1.573,1.573h2.44a.9.9,0,0,1,.882.882V8.263a1.58,1.58,0,0,1,1.117,2.69,1.519,1.519,0,0,1-1.117.456V14.29a.9.9,0,0,1-.882.882H4.455a.9.9,0,0,1-.882-.882Zm2.881-1.47a.578.578,0,1,0-.419-.169A.569.569,0,0,0,6.454,9.939Zm4.028,0a.578.578,0,1,0-.419-.169A.569.569,0,0,0,10.482,9.939ZM6,12.747h4.939v-.882H6ZM4.455,14.29h8.026V6.455H4.455Zm0,0v0Z" transform="translate(-4246.968 2525.614)"/>
              </g>
              </svg>`,
            },
            {
              title: this.$tc('app.ready_messages', 2),
              link: '/chat/macros',
              embed: `<span class="material-symbols-outlined">
              abc
              </span>`,
            },
            // {
            //   title: 'KPIs',
            //   link: '/live/kpis',
            //   embed: `<svg xmlns="http://www.w3.org/2000/svg" width="20.316" height="19.393" viewBox="0 0 20.316 19.393">
            //   <path id="query_stats_FILL0_wght400_GRAD0_opsz48" d="M3.131,18.568,2,17.737l4.34-6.926,2.77,3.232,3.671-5.956,2.516,3.74a4.374,4.374,0,0,0-.716.15q-.346.1-.693.242l-1.039-1.593L9.319,16.375,6.525,13.119Zm18.192,4.825L18.23,20.3a3.856,3.856,0,0,1-1.05.531,3.733,3.733,0,0,1-1.166.185,3.9,3.9,0,0,1-3.925-3.925,3.9,3.9,0,0,1,3.925-3.925,3.9,3.9,0,0,1,3.925,3.925,3.532,3.532,0,0,1-.2,1.166,5.118,5.118,0,0,1-.519,1.074L22.316,22.4Zm-5.31-3.763a2.547,2.547,0,0,0,1.8-4.34,2.547,2.547,0,0,0-3.6,3.6A2.45,2.45,0,0,0,16.014,19.63Zm1.708-7.572a2.882,2.882,0,0,0-.716-.185l-.762-.092L21.185,4l1.131.831Z" transform="translate(-2 -4)"/>
            //   </svg>`,
            // },
            {
              title: 'Relatório de uso',
              link: '/chat/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
          ],
        },
        {
          title: 'Flow',
          scope: 'flow',
          embed: '<span class="material-icons-outlined">account_tree</span>',
          subItems: [
            {
              title: 'Construtor de Fluxo',
              link: '/flows',
              embed: '<span class="material-icons-outlined">schema</span>',
            },
            {
              title: 'Templates',
              link: '/flows/templates',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="palette_FILL0_wght300_GRAD0_opsz48" d="M14.475,24a9.117,9.117,0,0,1-3.675-.75,9.559,9.559,0,0,1-5.05-5.062,9.491,9.491,0,0,1,.012-7.425A9.489,9.489,0,0,1,7.85,7.738a9.617,9.617,0,0,1,3.1-2.013A9.886,9.886,0,0,1,14.725,5a10.071,10.071,0,0,1,3.55.625,9.616,9.616,0,0,1,2.95,1.725A8.223,8.223,0,0,1,23.25,9.975,7.431,7.431,0,0,1,24,13.3a5.517,5.517,0,0,1-1.413,3.963,5.137,5.137,0,0,1-3.913,1.487H16.85a1.377,1.377,0,0,0-1.025.438A1.41,1.41,0,0,0,15.4,20.2a1.8,1.8,0,0,0,.363,1.188,1.54,1.54,0,0,1,.363,1.012,1.58,1.58,0,0,1-.425,1.188A1.689,1.689,0,0,1,14.475,24Zm.025-9.5ZM8.75,15a1.075,1.075,0,0,0,0-2.15,1,1,0,0,0-.725.325,1.028,1.028,0,0,0,0,1.5A1,1,0,0,0,8.75,15Zm3.125-4.175a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,11.875,10.825Zm5.25,0a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,17.125,10.825ZM20.325,15a1.112,1.112,0,1,0-.75-.325A1.03,1.03,0,0,0,20.325,15Zm-5.85,7.875a.588.588,0,0,0,.4-.112A.466.466,0,0,0,15,22.4a.884.884,0,0,0-.363-.663,1.7,1.7,0,0,1-.363-1.287,2.954,2.954,0,0,1,.738-2,2.36,2.36,0,0,1,1.863-.85h1.8a4.129,4.129,0,0,0,3.075-1.138A4.3,4.3,0,0,0,22.875,13.3a6.341,6.341,0,0,0-2.462-5.2,8.83,8.83,0,0,0-5.687-1.975,8.432,8.432,0,0,0-6.1,2.425,7.967,7.967,0,0,0-2.5,5.95,8.071,8.071,0,0,0,2.45,5.925A8.042,8.042,0,0,0,14.475,22.875Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Relatório de uso',
              link: '/flows/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
          ],
        },

        {
          // title: 'Omni Business',
          title: 'Pipelines',
          scope: 'pipelines',
          embed: '<span class="material-icons-outlined">filter_alt</span>',
          subItems: [
            {
              title: 'Pipelines',
              link: '/pipelines/',
              embed: '<span class="material-icons-outlined">filter_list</span>',
            },
            {
              title: 'Relatórios de uso',
              link: '/pipelines/reports/stat',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="insert_chart_FILL0_wght300_GRAD0_opsz48" d="M12.029,21.865a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V15.326a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433V21.25a.571.571,0,0,0,.2.433A.639.639,0,0,0,12.029,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433v-9.5a.591.591,0,0,0-.182-.433.676.676,0,0,0-.922,0,.591.591,0,0,0-.182.433v9.5a.591.591,0,0,0,.182.433A.625.625,0,0,0,16.5,21.865Zm4.471,0a.625.625,0,0,0,.461-.182.591.591,0,0,0,.182-.433V18.819a.571.571,0,0,0-.2-.433.639.639,0,0,0-.447-.182.625.625,0,0,0-.461.182.591.591,0,0,0-.182.433V21.25a.591.591,0,0,0,.182.433A.625.625,0,0,0,20.971,21.865ZM8.621,26A1.622,1.622,0,0,1,7,24.379V8.621A1.622,1.622,0,0,1,8.621,7H24.379A1.622,1.622,0,0,1,26,8.621V24.379A1.622,1.622,0,0,1,24.379,26Zm0-1.257H24.379a.338.338,0,0,0,.363-.363V8.621a.338.338,0,0,0-.363-.363H8.621a.338.338,0,0,0-.363.363V24.379a.338.338,0,0,0,.363.363Zm-.363,0v0Z" transform="translate(-7 -7)"/>
              </svg>`,
            },
          ],
        },

        {
          title: 'Yup Chat Gestão',
          scope: 'admin',
          permissions: 'whitelabel',
          embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.905" viewBox="0 0 19 19.905">
          <g id="Group_12855" data-name="Group 12855" transform="translate(4477.087 -1886.001)">
          <path id="Path_1242" data-name="Path 1242" d="M9.684,19.906h-6.1L2.152,16.678h5.38L0,0H3.587l0,.011C5.2,3.568,6.859,7.245,8.541,10.862A6.812,6.812,0,0,0,9.73,19.814l-.046.091ZM11.335,8.483h0c.787-1.649,1.537-3.308,2.293-5.074H6.815c-.2-.474-.38-.921-.552-1.354C5.981,1.343,5.715.671,5.38,0H18.83L15.157,7.926a6.893,6.893,0,0,0-.968-.068,6.752,6.752,0,0,0-2.853.625Z" transform="translate(-4477.087 1886)"/>
          <path id="settings_FILL1_wght300_GRAD0_opsz48" d="M9.146,14.907l-.235-1.564A3.543,3.543,0,0,1,7.8,12.7l-1.46.665L5.3,11.531l1.317-.978a2.536,2.536,0,0,1-.039-.293q-.013-.163-.013-.306t.013-.293q.013-.163.039-.306L5.3,8.376,6.343,6.551,7.79,7.2a3.6,3.6,0,0,1,.534-.365A3.286,3.286,0,0,1,8.9,6.577L9.146,5h2.06l.235,1.577a4.509,4.509,0,0,1,.58.261,2.381,2.381,0,0,1,.515.365l1.486-.652,1.03,1.825-1.33.965q.026.156.039.313t.013.3q0,.13-.013.287t-.039.326l1.33.965-1.043,1.838L12.535,12.7a4.441,4.441,0,0,1-.521.372,2.211,2.211,0,0,1-.574.254l-.235,1.577Zm1.017-3.481a1.475,1.475,0,0,0,1.043-2.516A1.475,1.475,0,0,0,9.119,11,1.42,1.42,0,0,0,10.162,11.427Z" transform="translate(-4473.138 1890.741)"/>
          </g>
          </svg>`,
          subItems: [
            // {
            //   title: 'Clientes e fornecedores',
            //   link: '/foobar',
            //   embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="15.893" viewBox="0 0 19 15.893">
            //   <path id="manage_accounts_FILL0_wght400_GRAD0_opsz48" d="M11.648,15.92a3.438,3.438,0,0,1-3.585-3.585A3.438,3.438,0,0,1,11.648,8.75a3.438,3.438,0,0,1,3.585,3.585,3.438,3.438,0,0,1-3.585,3.585ZM4,23.592V21.345a2.782,2.782,0,0,1,.418-1.506,2.693,2.693,0,0,1,1.207-1.028,17.508,17.508,0,0,1,3.191-1.1,12.752,12.752,0,0,1,2.832-.335h.55a3.717,3.717,0,0,0-.215.657,7.041,7.041,0,0,0-.119.777h-.215a12.307,12.307,0,0,0-2.713.3A12.4,12.4,0,0,0,6.2,20.1a1.3,1.3,0,0,0-.574.538,1.444,1.444,0,0,0-.191.705v.813h6.429a4.647,4.647,0,0,0,.287.777,3.749,3.749,0,0,0,.406.657Zm14.029,1.052-.239-1.577a4.24,4.24,0,0,1-.825-.347,3.038,3.038,0,0,1-.705-.514l-1.314.287-.6-1,1.123-1.052a3.758,3.758,0,0,1,0-1.195L14.348,18.19l.6-1,1.314.287a3.038,3.038,0,0,1,.705-.514,4.24,4.24,0,0,1,.825-.347l.239-1.577h1.291l.239,1.577a4.24,4.24,0,0,1,.825.347,3.038,3.038,0,0,1,.705.514l1.314-.287.6,1-1.123,1.052a3.758,3.758,0,0,1,0,1.195L23,21.488l-.6,1-1.314-.287a3.038,3.038,0,0,1-.705.514,4.24,4.24,0,0,1-.825.347l-.239,1.577Zm.645-2.892a1.806,1.806,0,1,0-1.386-.526A1.874,1.874,0,0,0,18.674,21.751Zm-7.026-7.265A2.084,2.084,0,0,0,13.8,12.335a2.084,2.084,0,0,0-2.151-2.151A2.084,2.084,0,0,0,9.5,12.335a2.084,2.084,0,0,0,2.151,2.151ZM11.648,12.335ZM11.863,22.158Z" transform="translate(-4 -8.75)"/>
            //   </svg>`,
            // },
            {
              fallback: true,
              title: 'Whitelabel',
              link: '/admin/whitelabel',
              embed:
                '<span class="material-icons-outlined">add_business</span>',
            },
            {
              fallback: true,
              title: 'Clientes',
              link: '/admin/customers',
              embed:
                '<span class="material-icons-outlined">contact_mail</span>',
            },
            {
              permissions: 'yupchat',
              fallback: true,
              title: 'Fornecedores',
              link: '/admin/providers',
              embed: '<span class="material-icons-outlined">inventory_2</span>',
            },
            {
              permissions: 'yupchat',
              title: 'Antifraude',
              link: '/admin/antifraud',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22.71" viewBox="0 0 18 22.71">
              <path id="policy_FILL0_wght300_GRAD0_opsz48" d="M18,18.96a2.567,2.567,0,0,0,1.845-.735,2.452,2.452,0,0,0,.765-1.845,2.49,2.49,0,0,0-.78-1.845,2.6,2.6,0,0,0-4.44,1.845,2.429,2.429,0,0,0,.78,1.845A2.582,2.582,0,0,0,18,18.96Zm0,7.44a10.486,10.486,0,0,0,2.925-1.545A9.608,9.608,0,0,0,23.28,22.44l-2.94-2.85a6.115,6.115,0,0,1-1.125.54A3.569,3.569,0,0,1,18,20.34a3.944,3.944,0,0,1-3.96-3.96A3.944,3.944,0,0,1,18,12.42a3.944,3.944,0,0,1,3.96,3.96,3.863,3.863,0,0,1-.18,1.17,3.932,3.932,0,0,1-.51,1.05l2.76,2.67a13.691,13.691,0,0,0,1.17-2.82,11.318,11.318,0,0,0,.45-3.21V9.33L18,6.57,10.35,9.33v5.91A11.939,11.939,0,0,0,12.5,22.185,10.636,10.636,0,0,0,18,26.4Zm0,1.41a11.431,11.431,0,0,1-6.45-4.635A13.382,13.382,0,0,1,9,15.24V8.46L18,5.1l9,3.36v6.78a13.382,13.382,0,0,1-2.55,7.935A11.431,11.431,0,0,1,18,27.81ZM17.97,16.47Z" transform="translate(-9 -5.1)"/>
              </svg>`,
            },
            {
              title: 'Suporte',
              link: '/admin/tickets',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="support_FILL0_wght400_GRAD0_opsz48" d="M21.1,10.626A8.649,8.649,0,0,0,16.374,5.9L14.925,9.462a3.968,3.968,0,0,1,1.568.986A4.822,4.822,0,0,1,17.538,12.1ZM10.674,5.9A9.05,9.05,0,0,0,7.657,7.883,7.206,7.206,0,0,0,5.9,10.7l3.539,1.425a4.77,4.77,0,0,1,1.069-1.663,4.1,4.1,0,0,1,1.591-1ZM5.9,16.326a9.626,9.626,0,0,0,1.948,2.921A7.927,7.927,0,0,0,10.626,21.1l1.5-3.562a4.275,4.275,0,0,1-1.6-.986A4.323,4.323,0,0,1,9.462,14.9ZM16.374,21.1a8.419,8.419,0,0,0,2.85-1.888A8.7,8.7,0,0,0,21.1,16.374L17.538,14.9a4.3,4.3,0,0,1-1.057,1.674,4.028,4.028,0,0,1-1.6.962ZM13.5,23a9.251,9.251,0,0,1-3.7-.748A9.485,9.485,0,0,1,4.748,17.2a9.548,9.548,0,0,1,0-7.41A9.485,9.485,0,0,1,9.8,4.748a9.548,9.548,0,0,1,7.41,0A9.485,9.485,0,0,1,22.252,9.8a9.548,9.548,0,0,1,0,7.41A9.485,9.485,0,0,1,17.2,22.252,9.251,9.251,0,0,1,13.5,23Zm0-6.65a2.838,2.838,0,0,0,2.85-2.85,2.838,2.838,0,0,0-2.85-2.85,2.838,2.838,0,0,0-2.85,2.85,2.838,2.838,0,0,0,2.85,2.85Z" transform="translate(-4 -4)"/>
              </svg>`,
            },
            {
              permissions: 'yupchat',
              fallback: true,
              title: 'Short Codes',
              link: '/admin/short-codes',
              embed: '<span class="material-icons-outlined">tag</span>',
            },
            {
              permissions: 'yupchat',
              fallback: true,
              title: 'Planos',
              link: '/admin/plans',
              embed:
                '<span class="material-icons-outlined">shopping_cart</span>',
            },
            {
              link: '/admin/sms/reports/stat',
              title: 'Relatório SMS',
              embed: `<svg id="SMS" xmlns="http://www.w3.org/2000/svg" width="19" height="18.005" viewBox="0 0 19 18.005">
          <path id="sms_FILL0_wght400_GRAD0_opsz48" d="M4,21.29V5.425a1.38,1.38,0,0,1,.427-.986,1.35,1.35,0,0,1,1-.439h16.15a1.363,1.363,0,0,1,.986.439A1.363,1.363,0,0,1,23,5.425v12.35A1.507,1.507,0,0,1,21.575,19.2H7.8L5.211,21.789a.659.659,0,0,1-.772.154A.651.651,0,0,1,4,21.29Zm1.425-1.734,1.781-1.781H21.575V5.425H5.425Zm0-14.131h0v12.35h0V5.425Z" transform="translate(-4 -4)"/>
          <path id="Path_1243" data-name="Path 1243" d="M.287-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,1.756-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135A.336.336,0,0,0,2.156-1.1a.364.364,0,0,0-.07-.22.757.757,0,0,0-.192-.179,2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5A1.094,1.094,0,0,1,.27-3.023,1.139,1.139,0,0,1,.4-3.587,1.12,1.12,0,0,1,.76-3.976,1.609,1.609,0,0,1,1.286-4.2a2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59A1.082,1.082,0,0,1,2.657-.2a1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,.828.015,1.985,1.985,0,0,1,.287-.161ZM8.631,0H7.7V-2.514q0-.407.035-.9H7.708a4.426,4.426,0,0,1-.132.557L6.592,0H5.818l-1-2.827a5.5,5.5,0,0,1-.132-.586H4.658q.038.621.038,1.09V0H3.844V-4.2H5.229l.858,2.49a3.506,3.506,0,0,1,.149.6h.018a6.047,6.047,0,0,1,.167-.606L7.28-4.2H8.631Zm.762-.161V-1.1a1.8,1.8,0,0,0,.554.321,1.78,1.78,0,0,0,.6.107A1.338,1.338,0,0,0,10.862-.7a.731.731,0,0,0,.223-.089.39.39,0,0,0,.133-.135.336.336,0,0,0,.044-.168.364.364,0,0,0-.07-.22A.757.757,0,0,0,11-1.494a2.005,2.005,0,0,0-.289-.158q-.167-.076-.36-.155a1.839,1.839,0,0,1-.734-.5,1.094,1.094,0,0,1-.242-.715,1.139,1.139,0,0,1,.132-.564,1.12,1.12,0,0,1,.359-.388,1.609,1.609,0,0,1,.526-.224,2.7,2.7,0,0,1,.633-.072,3.806,3.806,0,0,1,.582.04,2.287,2.287,0,0,1,.467.122v.876a1.413,1.413,0,0,0-.23-.129,1.822,1.822,0,0,0-.256-.092,1.955,1.955,0,0,0-.262-.054,1.856,1.856,0,0,0-.248-.018,1.291,1.291,0,0,0-.293.031.751.751,0,0,0-.223.086.43.43,0,0,0-.141.133.316.316,0,0,0-.05.174.333.333,0,0,0,.056.189.639.639,0,0,0,.158.158,1.679,1.679,0,0,0,.249.146q.146.072.331.148a3.689,3.689,0,0,1,.453.224,1.609,1.609,0,0,1,.344.268,1.044,1.044,0,0,1,.22.341,1.206,1.206,0,0,1,.076.447,1.2,1.2,0,0,1-.133.59,1.082,1.082,0,0,1-.362.387,1.569,1.569,0,0,1-.532.212,3.073,3.073,0,0,1-.64.064A3.559,3.559,0,0,1,9.933.015,1.985,1.985,0,0,1,9.393-.161Z" transform="translate(3 9)"/>
          </svg>`,
            },
            {
              link: '/admin/email/reports/stat',
              title: 'Relatório E-mail',
              scope: 'mail',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="15.2" viewBox="0 0 19 15.2">
          <path id="mail_FILL0_wght400_GRAD0_opsz48" d="M5.425,23.2A1.461,1.461,0,0,1,4,21.775V9.425A1.461,1.461,0,0,1,5.425,8h16.15A1.461,1.461,0,0,1,23,9.425v12.35A1.461,1.461,0,0,1,21.575,23.2Zm16.15-12.469-7.7,5.035q-.1.048-.178.083a.59.59,0,0,1-.4,0q-.083-.036-.178-.083L5.425,10.731V21.775h16.15ZM13.5,14.6l7.98-5.177H5.544ZM5.425,10.731V21.775h0Z" transform="translate(-4 -8)"/>
          </svg>`,
            },
            {
              title: 'Relatório WhatsApp',
              link: '/admin/whatsapp/reports/stat',
              scope: 'whatsapp',
              icon: 'fab fa-whatsapp',
            },
            {
              title: 'Relatório RCS',
              icon: 'fab fa-google',
              link: '/admin/rcs/reports/stat',
              scope: 'rcs',
            },
            /* {
              link: '/admin/sms/history',
              icon: 'fas fa-history',
              title: 'Histórico',
            }, */
            {
              permissions: 'yupchat',
              link: '/admin/sms/monitor',
              icon: 'fas fa-desktop',
              title: 'Monitor',
            },
            {
              permissions: 'yupchat',
              link: '/admin/logs',
              title: 'Log',
              embed: '<span class="material-symbols-outlined">receipt_long</span>',
            },
          ],
        },

        // {
        //   title: 'Catálogo',
        //   link: '/catalog/list',
        //   embed: '<span class="material-icons-outlined">storefront</span>',
        // },
        // {
        //   title: 'Workflow',
        //   link: '/workflow/workspace',
        //   embed: '<span class="material-icons-outlined">table_chart</span>',
        // },
        {
          title: 'Mais',
          icon: 'fas fa-ellipsis-h',
          subItems: [
            /* {
              title: 'Configurações',
              link: '/settings',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19.431" viewBox="0 0 19 19.431">
              <path id="settings_FILL0_wght400_GRAD0_opsz48" d="M15.55,23.431H12.344a.724.724,0,0,1-.474-.17.714.714,0,0,1-.255-.437l-.389-2.453a6.508,6.508,0,0,1-.972-.461,6.675,6.675,0,0,1-.9-.607L7.1,20.347a.722.722,0,0,1-.534.036.7.7,0,0,1-.413-.352l-1.6-2.842a.631.631,0,0,1-.073-.51.81.81,0,0,1,.291-.437l2.089-1.53a2.888,2.888,0,0,1-.061-.5q-.012-.279-.012-.5t.012-.5a2.888,2.888,0,0,1,.061-.5L4.766,11.19a.81.81,0,0,1-.291-.437.631.631,0,0,1,.073-.51L6.15,7.4a.7.7,0,0,1,.413-.352.722.722,0,0,1,.534.036L9.356,8.129a6.675,6.675,0,0,1,.9-.607,5.026,5.026,0,0,1,.972-.437l.389-2.478a.714.714,0,0,1,.255-.437A.724.724,0,0,1,12.344,4H15.55a.724.724,0,0,1,.474.17.714.714,0,0,1,.255.437l.389,2.453a7.875,7.875,0,0,1,.984.449,4.181,4.181,0,0,1,.887.619L20.8,7.085a.722.722,0,0,1,.534-.036.7.7,0,0,1,.413.352l1.6,2.818a.694.694,0,0,1,.085.522.72.72,0,0,1-.3.449L21.04,12.671a3.423,3.423,0,0,1,.061.522q.012.279.012.522t-.012.51a3.382,3.382,0,0,1-.061.51l2.089,1.506a.81.81,0,0,1,.291.437.631.631,0,0,1-.073.51l-1.6,2.842a.7.7,0,0,1-.413.352.722.722,0,0,1-.534-.036L18.538,19.3a8.058,8.058,0,0,1-.887.619,4.233,4.233,0,0,1-.984.449l-.389,2.453a.714.714,0,0,1-.255.437A.724.724,0,0,1,15.55,23.431Zm-1.6-6.558A3.151,3.151,0,0,0,17.1,13.716a3.151,3.151,0,0,0-3.158-3.158,3.151,3.151,0,0,0-3.158,3.158,3.151,3.151,0,0,0,3.158,3.158Zm0-1.457a1.7,1.7,0,1,1,1.2-.5A1.638,1.638,0,0,1,13.947,15.416Zm0-1.7Zm-1.069,8.258h2.137l.34-2.72a5.728,5.728,0,0,0,1.518-.607,6.226,6.226,0,0,0,1.3-1l2.575,1.117.972-1.749-2.283-1.676q.1-.413.158-.814a5.424,5.424,0,0,0,.061-.814,6.756,6.756,0,0,0-.049-.814,5.026,5.026,0,0,0-.17-.814l2.283-1.676-.972-1.749L18.173,9.781A5.414,5.414,0,0,0,16.91,8.724a4.1,4.1,0,0,0-1.555-.547l-.34-2.72H12.878l-.34,2.72A5.146,5.146,0,0,0,11,8.761a5.357,5.357,0,0,0-1.275,1.02L7.146,8.664l-.972,1.749,2.283,1.676q-.1.413-.158.814a5.482,5.482,0,0,0,0,1.627q.061.4.158.814L6.175,17.019l.972,1.749,2.575-1.117a6.226,6.226,0,0,0,1.3,1,5.728,5.728,0,0,0,1.518.607Z" transform="translate(-4.45 -4)"/>
              </svg>`,
            }, */
            {
              title: 'Usuários e Departamentos',
              link: '/users',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="badge_FILL0_wght300_GRAD0_opsz48" d="M20.325,15.875a.468.468,0,0,0,.362-.15.534.534,0,0,0,.138-.375.459.459,0,0,0-.138-.338.49.49,0,0,0-.362-.137H17.15a.5.5,0,0,0-.35.137.513.513,0,0,0,0,.725.5.5,0,0,0,.35.137Zm0,2.575a.468.468,0,0,0,.362-.15.534.534,0,0,0,.138-.375.472.472,0,0,0-.5-.5H17.15a.513.513,0,0,0-.5.5.509.509,0,0,0,.15.375.48.48,0,0,0,.35.15ZM16.7,10h5.85A1.451,1.451,0,0,1,24,11.45v11.1A1.451,1.451,0,0,1,22.55,24H6.45A1.451,1.451,0,0,1,5,22.55V11.45A1.451,1.451,0,0,1,6.45,10H12.3V6.125a1.061,1.061,0,0,1,.35-.787A1.121,1.121,0,0,1,13.45,5h2.125A1.153,1.153,0,0,1,16.7,6.125Zm-3.25,1.125h2.125v-5H13.45Zm1.05,6Zm-3.1.3A1.238,1.238,0,0,0,12.625,16.2a1.207,1.207,0,0,0-.362-.888,1.178,1.178,0,0,0-.863-.363,1.238,1.238,0,0,0-1.25,1.25,1.178,1.178,0,0,0,.363.862A1.207,1.207,0,0,0,11.4,17.425Zm-2.9,2.65h5.675V19.85a1.293,1.293,0,0,0-.2-.712,1.07,1.07,0,0,0-.525-.438,8.063,8.063,0,0,0-1.163-.337,4.776,4.776,0,0,0-.888-.088,5.35,5.35,0,0,0-1,.1,7.659,7.659,0,0,0-1.15.325,1.058,1.058,0,0,0-.55.438,1.293,1.293,0,0,0-.2.712Zm3.8-8.95H6.45a.3.3,0,0,0-.325.325v11.1a.3.3,0,0,0,.325.325h16.1a.3.3,0,0,0,.325-.325V11.45a.3.3,0,0,0-.325-.325H16.7a1.028,1.028,0,0,1-.363.875,1.509,1.509,0,0,1-.937.275H13.6A1.522,1.522,0,0,1,12.675,12,1.012,1.012,0,0,1,12.3,11.125Z" transform="translate(-5 -5)"/>
              </svg>`,
            },
            {
              title: 'Canais',
              link: '/channels',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="23.02" height="17.919" viewBox="0 0 23.02 17.919">
              <path id="canais_settings" data-name="canais settings" d="M-257.39,577.945a.358.358,0,0,1-.245-.09.382.382,0,0,1-.129-.219l-.181-1.236a3.188,3.188,0,0,1-.572-.265,3.15,3.15,0,0,1-.522-.367l-1.133.528a.405.405,0,0,1-.276.006.38.38,0,0,1-.212-.174l-.7-1.236a.324.324,0,0,1-.039-.265.37.37,0,0,1,.155-.212l1.03-.772a2.637,2.637,0,0,1-.039-.29c-.008-.107-.013-.209-.013-.3s0-.183.013-.29.022-.209.039-.3l-1.03-.772a.37.37,0,0,1-.155-.212.321.321,0,0,1,.039-.264l.7-1.224a.411.411,0,0,1,.212-.18.317.317,0,0,1,.264.013l1.133.516a3.556,3.556,0,0,1,.528-.361,3.255,3.255,0,0,1,.566-.257l.193-1.249a.382.382,0,0,1,.129-.219.358.358,0,0,1,.245-.09H-256a.369.369,0,0,1,.238.09.374.374,0,0,1,.135.219l.18,1.249a4.49,4.49,0,0,1,.573.257,2.367,2.367,0,0,1,.508.361l1.159-.516a.336.336,0,0,1,.264-.019.383.383,0,0,1,.212.174l.7,1.223a.361.361,0,0,1,.045.271.333.333,0,0,1-.161.219l-1.043.76c.017.1.03.206.039.309s.013.2.013.3,0,.18-.013.283-.022.211-.039.322l1.043.76a.341.341,0,0,1,.148.212.345.345,0,0,1-.045.265l-.695,1.236a.386.386,0,0,1-.212.174.335.335,0,0,1-.265-.019l-1.146-.516a4.4,4.4,0,0,1-.515.367,2.174,2.174,0,0,1-.567.251l-.18,1.249a.374.374,0,0,1-.135.219.369.369,0,0,1-.238.09Zm-.348-5.923a1.406,1.406,0,0,0-.425,1.03,1.405,1.405,0,0,0,.425,1.03,1.4,1.4,0,0,0,1.03.425,1.4,1.4,0,0,0,1.031-.425,1.4,1.4,0,0,0,.425-1.03,1.406,1.406,0,0,0-.425-1.03,1.4,1.4,0,0,0-1.031-.425A1.4,1.4,0,0,0-257.738,572.022Zm-15.781,4.5a1.411,1.411,0,0,1-1.036-.45,1.451,1.451,0,0,1-.445-1.05v-13.5a1.45,1.45,0,0,1,.445-1.05,1.411,1.411,0,0,1,1.036-.45H-256.4a1.411,1.411,0,0,1,1.036.45,1.45,1.45,0,0,1,.445,1.05v6.15H-256.4v-6.15h-17.117v13.5h11.2v1.5Zm4.975-2.944-.748-1.686h2.808l-3.932-8.709h1.872c1.312,2.9,2.623,5.806,4.027,8.709l-.843,1.686Zm3.465-4.776c.655-1.31,1.218-2.529,1.779-3.839h-3.559c-.281-.655-.468-1.217-.75-1.779h7.025l-3.559,7.68C-264.424,570.211-264.7,569.556-265.079,568.806Z" transform="translate(275 -560.026)"/>
              </svg>`,
            },
            {
              title: 'Minhas faturas',
              // link: '/invoices',
              link: '/billing',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18.91" viewBox="0 0 19 18.91">
              <path id="currency_exchange_FILL0_wght300_GRAD0_opsz48" d="M12.4,21.91a8.688,8.688,0,0,1-4.941-1.553A11.113,11.113,0,0,1,3.913,16.62v2.656a.526.526,0,0,1-.135.371.467.467,0,0,1-.36.146.5.5,0,0,1-.518-.518V15.494a.618.618,0,0,1,.653-.653H7.335a.518.518,0,1,1,0,1.036H4.678a9.286,9.286,0,0,0,3.185,3.534A7.919,7.919,0,0,0,12.4,20.9a8.181,8.181,0,0,0,5.718-2.206A8.094,8.094,0,0,0,20.8,13.2a.591.591,0,0,1,.169-.371.545.545,0,0,1,.743,0,.437.437,0,0,1,.124.371,9.423,9.423,0,0,1-.945,3.411,9.629,9.629,0,0,1-2.049,2.769,9.43,9.43,0,0,1-2.915,1.857A9.232,9.232,0,0,1,12.4,21.91ZM3.463,12.23a.5.5,0,0,1-.371-.146.437.437,0,0,1-.124-.371,9.355,9.355,0,0,1,.957-3.456A9.5,9.5,0,0,1,8.911,3.664,9.224,9.224,0,0,1,12.4,3a8.758,8.758,0,0,1,4.941,1.553,10.693,10.693,0,0,1,3.546,3.782v-2.7a.526.526,0,0,1,.135-.371.467.467,0,0,1,.36-.146.5.5,0,0,1,.518.518V9.416a.618.618,0,0,1-.653.653H17.465a.518.518,0,1,1,0-1.036h2.656a9.366,9.366,0,0,0-3.163-3.512A7.871,7.871,0,0,0,12.4,4.013,8.224,8.224,0,0,0,6.727,6.2,8.1,8.1,0,0,0,4,11.712a.591.591,0,0,1-.169.371A.5.5,0,0,1,3.463,12.23Zm8.915,6.461a.5.5,0,0,1-.349-.135.44.44,0,0,1-.146-.338v-.7a4.2,4.2,0,0,1-1.452-.642A3.9,3.9,0,0,1,9.361,15.7a.339.339,0,0,1-.045-.371.564.564,0,0,1,.293-.281.481.481,0,0,1,.326.023.525.525,0,0,1,.236.225,2.736,2.736,0,0,0,.991,1.036,2.637,2.637,0,0,0,1.4.383,2.523,2.523,0,0,0,1.531-.5,1.586,1.586,0,0,0,.675-1.351,1.518,1.518,0,0,0-.507-1.193,7.6,7.6,0,0,0-2.06-1.058,5.859,5.859,0,0,1-2.15-1.193,2.328,2.328,0,0,1-.574-1.666,2.243,2.243,0,0,1,.642-1.6,2.951,2.951,0,0,1,1.812-.833V6.714a.5.5,0,0,1,.991,0v.608a3.013,3.013,0,0,1,2.139,1.216.384.384,0,0,1,.056.349.436.436,0,0,1-.259.281.408.408,0,0,1-.338.034.607.607,0,0,1-.293-.191,2.247,2.247,0,0,0-.754-.63,2.216,2.216,0,0,0-1.024-.225,2.263,2.263,0,0,0-1.452.439,1.409,1.409,0,0,0-.552,1.159,1.552,1.552,0,0,0,.484,1.193,5.841,5.841,0,0,0,1.947.945,5.681,5.681,0,0,1,2.217,1.2,2.436,2.436,0,0,1,.642,1.767,2.371,2.371,0,0,1-.833,1.9,3.436,3.436,0,0,1-2.026.8v.63a.5.5,0,0,1-.5.5Z" transform="translate(-2.9 -3)"/>
              </svg>`,
            },
            {
              title: 'Webhooks',
              link: '/webhooks',
              embed: `
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18.026" viewBox="0 0 19 18.026">
              <path id="webhook_FILL0_wght300_GRAD0_opsz48" d="M8.958,22.526a4.3,4.3,0,0,1-3.154-1.3,4.3,4.3,0,0,1-1.3-3.154,4.34,4.34,0,0,1,.853-2.643,4.208,4.208,0,0,1,2.192-1.571v1.194a3.338,3.338,0,0,0-1.4,1.206A3.184,3.184,0,0,0,5.6,18.068a3.368,3.368,0,0,0,3.362,3.362,3.2,3.2,0,0,0,2.363-.987,3.258,3.258,0,0,0,.974-2.375v-.536h5.749a1.16,1.16,0,0,1,.426-.438,1.089,1.089,0,0,1,.572-.171,1.149,1.149,0,0,1,.828.329,1.088,1.088,0,0,1,.341.816,1.164,1.164,0,0,1-1.169,1.169,1.089,1.089,0,0,1-.572-.171,1.16,1.16,0,0,1-.426-.438H13.391a4.721,4.721,0,0,1-1.571,2.813A4.255,4.255,0,0,1,8.958,22.526Zm10.085,0a4.3,4.3,0,0,1-1.949-.451,4.732,4.732,0,0,1-1.559-1.254h1.608a3.4,3.4,0,0,0,.889.451,3.176,3.176,0,0,0,1.011.158A3.368,3.368,0,0,0,22.4,18.068a3.2,3.2,0,0,0-.987-2.363,3.4,3.4,0,0,0-3.191-.877,2.906,2.906,0,0,0-.719.292L14.536,10.1a1.32,1.32,0,0,1-.84-.341,1.032,1.032,0,0,1-.353-.8,1.128,1.128,0,0,1,.341-.828,1.1,1.1,0,0,1,.8-.341,1.088,1.088,0,0,1,.816.341,1.149,1.149,0,0,1,.329.828A.844.844,0,0,1,15.6,9.2a2.826,2.826,0,0,1-.11.292l2.509,4.238q.268-.049.536-.073t.512-.024A4.317,4.317,0,0,1,22.2,14.926a4.455,4.455,0,0,1,0,6.3A4.3,4.3,0,0,1,19.042,22.526ZM8.958,19.237a1.164,1.164,0,0,1-1.169-1.169,1.034,1.034,0,0,1,.341-.767,1.377,1.377,0,0,1,.853-.378l2.7-4.531a5.034,5.034,0,0,1-1.218-1.571,4.161,4.161,0,0,1-.438-1.863A4.47,4.47,0,0,1,14.487,4.5a4.454,4.454,0,0,1,4.458,4.263H17.824A3.148,3.148,0,0,0,16.8,6.522,3.246,3.246,0,0,0,14.487,5.6a3.2,3.2,0,0,0-2.363.987,3.258,3.258,0,0,0-.974,2.375,3.174,3.174,0,0,0,.56,1.839A3.672,3.672,0,0,0,13.2,12.051L9.932,17.508a2.232,2.232,0,0,1,.122.292.853.853,0,0,1,.049.268,1.149,1.149,0,0,1-.329.828,1.088,1.088,0,0,1-.816.341Z" transform="translate(-4.5 -4.5)"/>
              </svg>`,
            },
            {
              title: 'Suporte',
              link: '/support',
              embed: `<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
              <path id="support_FILL0_wght400_GRAD0_opsz48" d="M21.1,10.626A8.649,8.649,0,0,0,16.374,5.9L14.925,9.462a3.968,3.968,0,0,1,1.568.986A4.822,4.822,0,0,1,17.538,12.1ZM10.674,5.9A9.05,9.05,0,0,0,7.657,7.883,7.206,7.206,0,0,0,5.9,10.7l3.539,1.425a4.77,4.77,0,0,1,1.069-1.663,4.1,4.1,0,0,1,1.591-1ZM5.9,16.326a9.626,9.626,0,0,0,1.948,2.921A7.927,7.927,0,0,0,10.626,21.1l1.5-3.562a4.275,4.275,0,0,1-1.6-.986A4.323,4.323,0,0,1,9.462,14.9ZM16.374,21.1a8.419,8.419,0,0,0,2.85-1.888A8.7,8.7,0,0,0,21.1,16.374L17.538,14.9a4.3,4.3,0,0,1-1.057,1.674,4.028,4.028,0,0,1-1.6.962ZM13.5,23a9.251,9.251,0,0,1-3.7-.748A9.485,9.485,0,0,1,4.748,17.2a9.548,9.548,0,0,1,0-7.41A9.485,9.485,0,0,1,9.8,4.748a9.548,9.548,0,0,1,7.41,0A9.485,9.485,0,0,1,22.252,9.8a9.548,9.548,0,0,1,0,7.41A9.485,9.485,0,0,1,17.2,22.252,9.251,9.251,0,0,1,13.5,23Zm0-6.65a2.838,2.838,0,0,0,2.85-2.85,2.838,2.838,0,0,0-2.85-2.85,2.838,2.838,0,0,0-2.85,2.85,2.838,2.838,0,0,0,2.85,2.85Z" transform="translate(-4 -4)"/>
              </svg>`,
            },
          ],
        },
      ],
    };
  },
  methods: {
    closeModalMenus() {
      Object.keys(this.alternativeAccordions).forEach((menu) => {
        this.alternativeAccordions[menu] = false;
      });
    },
    activeMainMenu(route, menu) {
      if (!route || route === '/') return false;

      route = `${route.replace(/\/+$/, '')}/`;

      if (
        menu.link?.indexOf(route) === 0 ||
        route?.indexOf(`/${menu.scope}/`) === 0
      ) {
        return true;
      }

      return menu?.subItems?.some(
        (item) => item.link && route.indexOf(item.link) === 0,
      );
    },
    updateScrollBar() {
      if (this.updateScrollBarTimeout) {
        clearTimeout(this.updateScrollBarTimeout);
      }

      this.updateScrollBarTimeout = setTimeout(
        () => this.triggerUpdateScrollbar(),
        500,
      );
    },
    triggerUpdateScrollbar() {
      const update = this.$refs.sidebarScroll?.update;

      console.log('accordions', { update });

      if (update) update();
    },
    checkClient() {
      Promise.all([WhatsAppService.getClient()])
        .then(
          (responses) => {
            // permissions === 'yupchat' && this.account.whitelabel_id === null
            // Vue.set(this.available, 'rcs', responses[0]?.data?.active === true);
            Vue.set(
              this.available,
              'whatsapp',
              responses[0]?.data?.active === true,
            );

            this.$live.activeWhatsApp360(responses[0]?.data?.active);

            this.$forceUpdate();
          },
          (error) => {
            this.content = error;
          },
        )
        .finally(() => {
          this.fetched = true;
        });
    },

    forceEnableSoundNotification() {
      // console.log('this.$refs.soundNotification', this.$refs.soundNotification);

      if (
        !this.audioEnabled &&
        this.$live &&
        this.$refs.soundNotification &&
        this.$refs.soundNotification[0]
      ) {
        const sound = this.$refs.soundNotification[0];
        sound.muted = true;
        sound.play();
        sound.pause();
        sound.muted = false;
        this.audioEnabled = true;
        sound.volume = 0.2;
      }
    },
    emitLiveNotification() {
      // const path = this.$router.history.current.path;

      this.hasNotification = true; // path.indexOf('/live') !== 0;

      if (!this.timeoutSoundRunning && !this.isMuted) {
        clearTimeout(this.timeoutSound);

        this.timeoutSound = setTimeout(() => {
          // if (!this.isMuted) this.$refs.soundNotification.play();

          if (this.$refs.soundNotification && this.$refs.soundNotification[0]) {
            const sound = this.$refs.soundNotification[0];
            sound.volume = 0.2;

            const played = sound.play();

            if (!this.audioEnabled && played.catch && !this.audioIssue) {
              played
                .then(() => {
                  this.audioIssue = false;
                })
                .catch(() => {
                  this.audioIssue = true;

                  /* this.$toast.show({
                    title: this.$tc('generic-str.notification', 2),
                    content: this.$t('generic-str.sound-notification'),
                    type: 'info',
                    requireInteraction: (accepted) => {
                      if (accepted) this.forceEnableSoundNotification();
                    },
                  }); */
                  this.forceEnableSoundNotification();
                });
            }
          }

          this.timeoutSoundRunning = true;

          // Permite nova notificações somente após 2 segundos
          setTimeout(() => {
            this.timeoutSoundRunning = false;
          }, 2000);
        }, 500);
      }
    },
  },
  watch: {
    accordions: {
      handler(newValue, oldValue) {
        console.log('accordions', { newValue, oldValue });
        this.updateScrollBar();
      },
      deep: true,
    },
    $route(to, from) {
      console.log('$route', this.currentRoute, { to, from });
      this.currentRoute = to?.path;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.darkmode #sidebar {
  border-right: thin solid var(--background-3);
}

.omni-pushs {
  position: absolute;
  right: 14px;
  top: 12px;
  border-radius: 40px;
  width: 12px;
  height: 12px;
  background: #f00;
  border: 2px solid #fff;

  &.omni-online {
    background: #00cc00;
  }

  &.omni-notifications {
    // animation-play-state: running;
    animation: bounceAnimation 0.4s ease-out infinite alternate;
  }
}

@keyframes bounceAnimation {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-5px);
  }
}

#sidebar {
  position: fixed;
  top: 62px;
  left: 0;
  border-right: thin solid #ededed;
  width: 80px;
  width: 62px;
  height: calc(100vh - 62px);
  background: #fff;
  overflow: hidden;

  &>.accordion {
    position: relative;
    border-right: thin solid rgba(0, 0, 0, 0.08);
    overflow: auto;
    overflow-x: hidden;
    // background-color: #fff;
    background-color: var(--background-2) !important;
    height: 100%;
    padding-bottom: 2rem;
  }

  &::v-deep .collapse {
    background: #f2f2f2;
    position: relative;

    &::before,
    &::after {
      content: '';
      position: absolute;
      left: 20px;
      top: 0;
      width: calc(100% - 40px);
      height: 0;
      border-top: thin solid #ccc;
    }

    &::after {
      top: auto;
      bottom: 0;
    }
  }

  &::v-deep .menu {
    color: #697077 !important;
    display: block !important;
    background: transparent !important;
    border-radius: 0.05rem;
    border: none;
    height: 52px;
    width: calc(100% - 0.1rem);
    margin: 0.2rem 0.05rem;
    padding: 0;
    font-size: 1.2rem;
    text-align: center;
    position: relative;

    &,
    i {
      transition: 0.06s all ease;
    }

    i {
      color: inherit !important;
      margin: 0 !important;
      pointer-events: none;
      // transform: scale(80%) translate(-50%, -50%) !important;
      transform: translate(-50%, -50%) !important;
      position: absolute;
      left: 50%;
      top: 50%;
      font-size: 8pt;

      &>span {
        font-size: 16pt;
      }

      &.icon-font {
        font-size: 11pt;
      }

      svg {
        fill: currentColor !important;
        width: 1rem !important;
        height: auto !important;
      }
    }

    &:hover {
      background: rgba(0, 0, 0, 0.024) !important;
      box-shadow: unset !important;
    }

    &.active,
    &:hover {
      color: var(--clr-yup-purple) !important;
    }
  }
}

.darkmode {
  #sidebar {
    &::v-deep .collapse {
      background-color: var(--background-3);
    }
  }
}

/* mobile */
#modal-menu {
  z-index: 1012;
  display: none;

  .card {
    transition: none !important;
  }

  &,
  .modal-submenu {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh !important;
    height: -moz-available !important;
    height: -webkit-fill-available !important;
    height: fill-available !important;
    height: stretch !important;
    /*
    min-height: 20vh;
    max-height: 70vh;
    */
    background-color: #fff;

    .card {
      border-radius: 0 !important;
    }

    &::before {
      position: fixed;
      z-index: -1;
      left: 0;
      bottom: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
      content: '';
    }
  }

  .modal-submenu {
    z-index: 1013;
  }

  .card {
    height: 100%;
    margin: 0;
    padding: 0.5rem 0 !important;

    .card-header {
      height: 55px;

      .material-icons-outlined {
        font-size: 1.3rem;
      }

      .btn {
        padding: 0.5rem !important;
      }
    }

    .card-body {
      padding: 0;
      height: calc(100% - 55px);

      .scroller {
        overflow: auto;
        overflow-x: hidden;
        width: 100%;
        height: 100%;
      }

      .items {
        padding: 0.5rem;
        margin: 0 auto;
        max-width: 500px;
        // display: grid;
        // grid-template-columns: 1fr 1fr 1fr 1fr;

        // .sub-title {
        //   position: absolute;
        //   width: 100%;
        //   bottom: 10px;
        //   left: 0;
        //   font-size: 80%;
        // }

        &>div {
          position: relative;
          // aspect-ratio: 1;
          height: 60px;

          // a.btn {
          //   display: flex;
          //   align-items: center;
          //   justify-content: center;
          // }

          &>.btn {
            font-weight: 400;
            height: auto !important;
            padding: 0.92rem;
            text-align: left !important;
            display: block;
            // height: 95%;
            width: 100%;
            // margin: 2.5% 0 0 2.5%;
            color: #697077 !important;
            // border: thin solid #f2eeee !important;
            background-color: transparent !important;

            &:hover,
            &.active {
              color: var(--clr-yup-purple) !important;
              // border-color: #752de6 !important;
              background-color: #f1eafc !important;
            }

            &>i {
              float: left;
              display: inline-block;
              color: inherit !important;
              margin-right: 1rem;

              &::v-deep {
                svg {
                  fill: currentColor;
                  width: 1rem;
                }

                &::before,
                .material-icons-outlined {
                  font-size: 1.2rem;
                }
              }
            }

            &>i.show-sub {
              margin: 0 0 0 1rem;
              float: right;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  #sidebar {
    display: none;
  }

  #modal-menu {
    display: block;
  }
}
</style>
